<template>
  <!-- <div class="mt-3"> -->
    <div class="card card-body px-0 pt-0 pb-3 table-border-radius" style="border-radius: 8px">
      <div class="row col-md-12 ml-0 py-4" style="">
        <div class="form-group mb-0">
          <ul class="nav nav-pills" role="tablist" id="tabs" style="font-size: 14px; font-weight: 500">
            <li class="nav-item type2 mr-4" v-if="role_id != 5">
              <a class="nav-link demo px-4" v-bind:class="[selectTab == 0 ? 'active' : '']" href="javascript:void(0);"
                v-on:click="selTab(0)" @click="demotabs(0)">All</a>
            </li>
            <li class="nav-item type1 mr-4" >
              <a class="nav-link demo" v-bind:class="[selectTab == 1 ? 'active' : '']" href="javascript:void(0);"
                v-on:click="selTab(1)" @click="demotabs(1)">Data Migration</a>
            </li>
            <li class="nav-item type2 mr-4" v-if="role_id != 5">
              <a class="nav-link demo" v-bind:class="[selectTab == 2 ? 'active' : '']" href="javascript:void(0);"
                v-on:click="selTab(2)" @click="demotabs(2)">Training Session</a>
            </li>
            <li class="nav-item type3 mr-4" v-if="role_id != 5">
              <a class="nav-link demo" v-bind:class="[selectTab == 3 ? 'active' : '']" href="javascript:void(0);"
                v-on:click="selTab(3)" @click="demotabs(3)">FollowUp</a>
            </li>
            <li class="nav-item type3 mr-4" v-if="role_id != 5">
              <a class="nav-link demo" v-bind:class="[selectTab == 5 ? 'active' : '']" href="javascript:void(0);"
                v-on:click="selTab(5)" @click="demotabs(5)">On-Hold</a>
            </li>
          </ul>
        </div>

        <div class="float-right ml-auto mt-1">
          <!-- Search -->
          <div class="float-left mr-3"  v-if="$can('onboarding_search')" >
            <div class="has-search">
              <span class="fa fa-search form-control-feedback"></span>
              <!-- <input v-model="search" @keyup="leadsBySearch" type="text" style="background-color: #edf2f5;" class="form-control" placeholder="Search Here..." /> -->
              <input v-model="search" @keyup="leadsBySearch" type="text" style="border-radius:4px !important;"
                class="form-control" placeholder="Search Here..." />
            </div>
          </div>
          <!-- End -->
        </div>
      </div>
      <div class="hide-scroll" style="overflow-y: auto">
        <!-- Table     -->
        <table class="table table-hover text-left px-0 mb-0" id="dataTable" width="100%" cellspacing="0">
          <thead ref="formContainer">
            <!-- <tr style="color: #48a6a6;background-color: #f4f8fa;border-bottom: 1.1px solid #93a8d6;border-top: 1.1px solid #93a8d6;"> -->
            <tr>
              <td></td>
              <td></td>
              <td>Name</td>
              <td>Phone</td>
              <td>Company</td>
              <td>Email</td>
              <td>Country</td>
              <!-- <td>Address</td> -->
              <td>Customer Interest</td>
              <td>Schedule For</td>
              <td>Status</td>
              <td class="text-right">Actions</td>
            </tr>
          </thead>
          <tbody v-show="isLoader">
            <tr id="table_row">
              <td colspan="16">
                <b-skeleton-wrapper>
                  <b-skeleton height="40px"></b-skeleton>
                  <b-skeleton height="40px"></b-skeleton>
                  <b-skeleton height="40px"></b-skeleton>
                </b-skeleton-wrapper>
              </td>
            </tr>
          </tbody>
          <tbody v-show="!isLoader" class="text-left" v-for="(lead, index) in demoLeads" :key="index">

            <tr class="text-left" :style="`border-left: 8px solid #${lead.color}`">
              <!-- name -->
              <td align="right">
                <button @click="showOnboarding(lead.id, lead.onboardlead, lead)" class="btn btn-sm" type="button"
                  data-toggle="collapse" data-target="#boarding" aria-expanded="false" aria-controls="boarding">
                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" class="training_svg">
                    <path d="M4.66113 12.4307L7.99864 15.7682L11.3362 12.4307" stroke="#48A6A6" stroke-width="1.5" />
                    <path d="M11.3359 4.82324L7.99843 1.48573L4.66092 4.82324" stroke="#48A6A6" stroke-width="1.5" />
                    <line x1="-0.000976497" y1="8.53955" x2="15.9991" y2="8.53955" stroke="#48A6A6" stroke-width="1.5" />
                  </svg>
                </button>
              </td>
              <td>
                <!-- <a @click="quickView"> -->
                <!-- <a> -->
                  <!-- <i :data-id="lead.id" class="fa fa-eye quick-view-color" style="cursor: pointer; margin-bottom: 9px;">
                  </i>
                </a> -->
              </td>
              <b-tooltip v-if="lead.name.length >= 10" :target="'lead' + lead.id" placement="bottom" style="">
                {{ lead.name }}
              </b-tooltip>
              <!-- <td v-if="lead.name.length >= 10" :id="'lead'+lead.id" class="text-primary">{{ lead.name.substring(0,10) + '...'}}</td>
              <td v-else class="text-primary">{{ lead.name }}</td> -->
              <td v-if="lead.name.length >= 10" :id="'lead' + lead.id" style="color:#48A6A6;">{{ lead.name.substring(0,
                10) +
                '...' }}</td>
              <td v-else style="color:#48A6A6;">{{ lead.name }}</td>
              <!-- phone -->
              <td style="color:#323A47">
                {{ lead.phone }}
              </td>
              <!-- company -->
              <b-tooltip v-if="lead.company.length >= 15" :target="'company' + lead.id" placement="bottom" style="">
                {{ lead.company }}
              </b-tooltip>
              <td style="color:#323A47" v-if="lead.company.length >= 15" :id="'company' + lead.id">{{
                lead.company.substring(0, 15) + '...' }}</td>
              <td style="color:#323A47" v-else>{{ lead.company }}</td>
              <!-- email -->
              <td style="color:#323A47">{{ lead.email }}</td>
              <!-- country name -->
              <td style="color:#323A47">{{ lead.country }}</td>
              <!-- Address -->
              <!-- <td v-if="lead.street_address.length > 25" v-html="lead.street_address.substring(0, 25) + '...'" hover :title="lead.street_address"></td>
              <td v-else>{{ lead.street_address }}</td> -->
              <!-- Ceraetd at -->
              <td>
                <div class="pl-3" v-if="lead.onboardlead">
                  <span v-if="lead.onboardlead.customer_interest == 0" class="interest slow rounded-pill">{{
                    customer_interest(lead.onboardlead.customer_interest) }}</span>
                  <span v-if="lead.onboardlead.customer_interest == 1" class="interest v-slow rounded-pill">{{
                    customer_interest(lead.onboardlead.customer_interest) }}</span>
                  <span v-if="lead.onboardlead.customer_interest == 2" class="interest hyper rounded-pill">{{
                    customer_interest(lead.onboardlead.customer_interest) }}</span>
                </div>
                <div class="pl-3" v-else>
                  <span class="interest v-slow  rounded-pill">{{ customer_interest('') }}</span>
                </div>
              </td>
              <td style="color:#323A47"> 
                <span v-if="lead.sessions.length == 0 && lead.follow_ups.length == 0 && Object.keys(lead.data_request).length >0" style="color: #a682b2; font-weight: bold; font-size: 12px">
                  <span v-if="lead.data_request['0'].status == 0">{{ lead.data_request['0'].schedule_for | formatDate }}</span>
                  <span v-else-if="Object.keys(lead.data_migration).length >0 ">
                    <span v-if="lead.data_request['0'].status == 1 && lead.data_migration['0'].schedule_for != null ">{{ lead.data_migration['0'].schedule_for | formatDate}}</span>
                    <span v-else >{{ lead.data_migration['0'].expected_at | formatDate }}</span>
                  </span>
                </span>
                <span v-else-if="lead.sessions.length > 0 && lead.follow_ups.length == 0" style="color:#68b252;; font-weight: bold; font-size: 12px"> 
                  <span v-if="lead.sessions[lead.sessions.length-1].schedule_for != null ">{{ lead.sessions[lead.sessions.length-1].schedule_for | formatDate }}</span>
                  <span v-else >{{ lead.sessions[lead.sessions.length-1].expected_at | formatDate }}</span>
                </span>
                <span v-else-if="lead.follow_ups.length > 0" style="color:#e75b48;; font-weight: bold; font-size: 12px">
                  <span v-if="lead.follow_ups[lead.follow_ups.length-1].schedule_for != null ">{{ lead.follow_ups[lead.follow_ups.length-1].schedule_for | formatDate  }}</span>
                  <span v-else >{{ lead.follow_ups[lead.follow_ups.length-1].expected_at | formatDate }}</span>
                </span>
              </td>
              <!-- Interest -->
            
              <!-- Status -->
              <td>
                <span v-if="lead.sessions.length == 0 && lead.follow_ups.length == 0" style="color: #a682b2; font-weight: bold; font-size: 12px">
                  <span style="color:#a583b1;" class="bullet">• </span> <span style="color:#a583b1;">DATA MIGRATION</span>
                </span>
                <span v-else-if="lead.sessions.length > 0 && lead.follow_ups.length == 0"
                  style="color: #a682b2; font-weight: bold; font-size: 12px">
                  <span style="color:#68b252;" class="bullet">• </span> <span style="color:#68b252;">TRAINING SESSION
                  </span>
                </span>
                <span v-else-if="lead.follow_ups.length > 0"
                  style="color: #a682b2; font-weight: bold; font-size: 12px">
                  <span style="color:#e75b48;" class="bullet">• </span> <span style="color:#e75b48;">FOLLOW UP</span>
                </span>
                <span v-else style="color: #a682b2; font-weight: bold; font-size: 12px">
                  <span style="color:#a583b1;" class="bullet">• </span> DATA MIGRATION</span>
              </td>
              <td class="text-center">

                <a v-if="role_id != 5" class="btn dropdown-toggle" data-toggle="dropdown" href="#">
                  <span style="color:#767D87;" class="fas fa-ellipsis-v"></span>
                </a>
                <ul class="dropdown-menu action-list">
                  <li v-if="lead.follow_ups.length >= 2">
                    <a v-if="lead.follow_ups[1].status == 1" class="dropdown-item" @click="updateStatus" :data-id="lead.id" :data-status="5">Onboarded Successfully</a>
                  </li>
                  <li v-if="$can('onboarding_on_hold') && lead.on_hold == 0"> <a class="dropdown-item" @click="updateStatus" :data-id="lead.id" :data-status="6">On-Hold</a> </li>
                  <li v-if="lead.on_hold == 1">
                    <a class="dropdown-item" @click="updateStatus" :data-id="lead.id" :data-status="7">Resume</a>
                  </li>
                  <li v-if="$can('onboarding_extend_trail') && lead.on_hold == 0 && lead.org_status == 2">
                    <a class="dropdown-item" @click="trialenddate(lead.org_status,lead.org_id)">Extend Trial</a>
                  </li>
                  <li v-if="lead.on_hold == 0 && lead.org_status != 2">
                    <a class="dropdown-item" @click="startTrial(lead.org_id)">Start Organiztion Trial</a>
                  </li>
                  <li>
                <a class="dropdown-item" v-if="$can('onboarding_prospection_question')" @click="onBoarding" :data-id="lead.id" >Prospection Questions</a>
                  </li>
                  <li v-if="$can('onboarding_send_attachment_link') && lead.on_hold == 0 && lead.data_migration.length <=0">
                    <a class="dropdown-item" @click="attachmentLink(lead)">Send Attachment Link</a>
                  </li>
                </ul>
              </td>
            </tr>
            <transition name="transit">
              <tr v-if="row_id === lead.id">
                <td class="py-3" rowspan="5" colspan="12">
                  <div class="row px-2" style="background-color: #f7f8f9;">
                    <div class="col-4">
                      <div class="row">
                        <div class="col-sm-12 col-md-6">
                          <h5 class="font-weight-bolder pl-3 py-2" style="border-left: 3px solid rgb(165, 131, 177);">
                            Data Migration
                          </h5>
                        </div>
                        <div v-if="lead.attachments.length > 0 " class="col-sm-12 col-md-6 attachment" >
                          <a @click="open(lead.attachments)" class="btn dropdown-toggle float-right attachment_download" data-toggle="dropdown" href="#"><i class="fa fa-download " aria-hidden="true"></i></a>
                        </div>
                      </div>
                      <div class="card card-body border-0 hide-scroll "
                        style="height: 355px; border-radius: 10px; overflow-y: auto; ">
                        <div style="height: 325px; overflow-y: auto;  overflow-x:hidden; padding: 1.5rem 0rem;"
                          class="divScroll section-hide">
                          <div class="height:290px; overflow-y: auto; overflow-x:hidden; ">
                                <div v-show="lead.data_request.length > 0" v-for="(value, index) in lead.data_request" :key="index">
                                <div class="col-12 text-left ml-10">
                                  <div class="row">
                                    <div class="col-md-6">
                                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.5 6C9.5 7.933 7.933 9.5 6 9.5C4.067 9.5 2.5 7.933 2.5 6C2.5 4.067 4.067 2.5 6 2.5C7.933 2.5 9.5 4.067 9.5 6Z" fill="white" stroke="#48A6A6"/>
                                        <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z" stroke="#48A6A6" stroke-width="2"/>
                                      </svg>
                                      <label class="font-weight-bold section-heading">Request Data</label>
                                    </div> 
                                   
                                  </div>
                                  <div class="row">
                                    <div class="col-md-4">
                                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="7" cy="7" r="6" fill="white" stroke="#27AE60"/>
                                        <path d="M5.81771 8.84458C5.93106 8.94545 6.07749 9.00117 6.22921 9.00117C6.38094 9.00117 6.52737 8.94545 6.64071 8.84458L9.83271 5.91258C9.88692 5.86565 9.9304 5.8076 9.96021 5.74238C9.99001 5.67716 10.0054 5.60629 10.0054 5.53458C10.0054 5.46288 9.99001 5.39201 9.96021 5.32679C9.9304 5.26157 9.88692 5.20352 9.83271 5.15658C9.71937 5.05572 9.57294 5 9.42121 5C9.26949 5 9.12306 5.05572 9.00971 5.15658L6.22971 7.70958L4.99571 6.57858C4.88257 6.47731 4.73606 6.42132 4.58421 6.42132C4.43237 6.42132 4.28586 6.47731 4.17271 6.57858C4.1185 6.62552 4.07502 6.68357 4.04522 6.74879C4.01542 6.81401 4 6.88488 4 6.95658C4 7.02829 4.01542 7.09916 4.04522 7.16438C4.07502 7.2296 4.1185 7.28765 4.17271 7.33458L5.81771 8.84458Z" fill="#27AE60"/>
                                      </svg>
                                      <label class="form-check-label color-default font-weight-bold ">
                                        Request Data
                                      </label>
                                    </div>
                                      <div class="col-md-8">
                                        <small class="badge badge-success px-3 py-2 pull-right rounded-pill">{{   value.schedule_for | formatDate
                                        }}</small>
                                       
                                      </div>
                                  </div>
                                 <div class="row">
                                <div class="col-md-4">
                                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="7" cy="7" r="6" fill="white" stroke="#27AE60"/>
                                    <path d="M5.81771 8.84458C5.93106 8.94545 6.07749 9.00117 6.22921 9.00117C6.38094 9.00117 6.52737 8.94545 6.64071 8.84458L9.83271 5.91258C9.88692 5.86565 9.9304 5.8076 9.96021 5.74238C9.99001 5.67716 10.0054 5.60629 10.0054 5.53458C10.0054 5.46288 9.99001 5.39201 9.96021 5.32679C9.9304 5.26157 9.88692 5.20352 9.83271 5.15658C9.71937 5.05572 9.57294 5 9.42121 5C9.26949 5 9.12306 5.05572 9.00971 5.15658L6.22971 7.70958L4.99571 6.57858C4.88257 6.47731 4.73606 6.42132 4.58421 6.42132C4.43237 6.42132 4.28586 6.47731 4.17271 6.57858C4.1185 6.62552 4.07502 6.68357 4.04522 6.74879C4.01542 6.81401 4 6.88488 4 6.95658C4 7.02829 4.01542 7.09916 4.04522 7.16438C4.07502 7.2296 4.1185 7.28765 4.17271 7.33458L5.81771 8.84458Z" fill="#27AE60"/>
                                  </svg>
                                  <label class="form-check-label color-default font-weight-bold">
                                    Received
                                  </label>
                                </div>
                                <div class="col-8">
                                  <div v-if="isEditing">
                                    <input type="datetime-local" :min="value.schedule_for" v-model="receiveDate" class="form-control form-control-sm"/>
                                   <span style="    display: -webkit-inline-box;float: right;margin-top: 12px;">
                                  <i class="fa fa-check-circle mr-1" @click="saveDate(value.lead_onboarding_id,lead.name)" style="font-size: 19px; color: rgb(72, 166, 166); display: block; order: 1;"></i>
                                    <i class="fa fa-times-circle mr-1" style="font-size:19px;color:#a70909" @click="cancelEdit"></i>
                                   </span>
                                  </div>
                                <div v-else class="d-flex flex-row-reverse align-items-center justify-content-start">
                                 <div v-if="role_id==2 || role_id==1 || role_id==0 " >
                                      <span v-if="value.completed_at == null" class="fa fa-edit ml-1"
                                          style="cursor: pointer; color: #48A6A6" @click="editDate(value.completed_at)">
                                      </span>
                                    </div>
                                      <small v-if="value.stage == 1 && value.status == 1" class="badge badge-success px-3 py-2 br-2 pull-right rounded-pill">
                                          {{ value.completed_at | formatDate }}
                                      </small>
                                   
                                      <small v-else class="badge badge-warning px-3 py-2 pull-right rounded-pill">------</small>
                                    
                                  </div>
                                  </div>
                                </div>

                                </div>
                              </div>
                            </div>
                            <!-- {{lead}} -->
                            <div v-show="lead.data_migration.length > 0" v-for="(value, index) in lead.data_migration" :key="index">
                            <!-- {{value}} -->
                              <div class="col-12 text-left">
                                <div class="row">
                                  <div class="col-md-6">
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M9.5 6C9.5 7.933 7.933 9.5 6 9.5C4.067 9.5 2.5 7.933 2.5 6C2.5 4.067 4.067 2.5 6 2.5C7.933 2.5 9.5 4.067 9.5 6Z" fill="white" stroke="#48A6A6"/>
                                          <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z" stroke="#48A6A6" stroke-width="2"/>
                                        </svg>
                                    <label class="font-weight-bold section-heading">Data Migration</label>
                                  </div>
                                  <div v-if="role_id != 2" class="col-md-6 text-right">
                                      <i v-show="(lead.data_migration[index].schedule_for == null || (lead.data_migration[index].schedule_for != null && onboarding.is_completed == true)) && data_migration_edit_status" @click="save(2,index,lead.data_migration[index])" class="fa fa-check-circle mr-1" style="font-size:19px;color:#48A6A6"></i>
                                      <i v-show="data_migration_edit_status"  class="fa fa-times-circle" style="font-size:19px;color:#a70909" @click="sectionStyle(1,false)"></i>
                                      <span v-show="!data_migration_edit_status && ( lead.data_migration[0].stage== 2 && (lead.data_migration[0].status == 0 || lead.data_migration[0].status == 2))" @click="sectionStyle(1,true);
                                      onboarding.id =  lead.data_migration[index].id;
                                      onboarding.type = lead.data_migration[index].stage;
                                      onboarding.lead_onboarding_id = lead.data_migration[index].lead_onboarding_id;
                                      onboarding.schedule_for = (lead.data_migration[index].schedule_for != null) ? lead.data_migration[index].schedule_for :schDate;
                                      onboarding.schedule_comment = (lead.data_migration[index].schedule_comment != null) ? lead.data_migration[index].schedule_comment :'';
                                      onboarding.completed_comment = (lead.data_migration[index].completed_comment != null) ? lead.data_migration[index].completed_comment : null;
                                      onboarding.completed_at = (lead.data_migration[index].status == 2) ? lead.data_migration[index].completed_at:'';
                                      onboarding.stage_section = (lead.data_migration[index].schedule_for != null) ? 'completed': 'started';
                                      add_more = false;
                                      add_more_training_session = false;
                                      onboarding.next_expected_date = (lead.data_migration[index].schedule_at != null) ? lead.data_migration[index].schedule_at :schDate;
                                      onboarding.zoom_meeting = false;
                                      onboarding.org_id = lead.org_id;
                                      "
                                        class="fa fa-edit ml-1"
                                        style="cursor: pointer; color: #48A6A6">
                                        </span>
                                    </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="7" cy="7" r="6" fill="white" stroke="#27AE60"/>
                                          <path d="M5.81771 8.84458C5.93106 8.94545 6.07749 9.00117 6.22921 9.00117C6.38094 9.00117 6.52737 8.94545 6.64071 8.84458L9.83271 5.91258C9.88692 5.86565 9.9304 5.8076 9.96021 5.74238C9.99001 5.67716 10.0054 5.60629 10.0054 5.53458C10.0054 5.46288 9.99001 5.39201 9.96021 5.32679C9.9304 5.26157 9.88692 5.20352 9.83271 5.15658C9.71937 5.05572 9.57294 5 9.42121 5C9.26949 5 9.12306 5.05572 9.00971 5.15658L6.22971 7.70958L4.99571 6.57858C4.88257 6.47731 4.73606 6.42132 4.58421 6.42132C4.43237 6.42132 4.28586 6.47731 4.17271 6.57858C4.1185 6.62552 4.07502 6.68357 4.04522 6.74879C4.01542 6.81401 4 6.88488 4 6.95658C4 7.02829 4.01542 7.09916 4.04522 7.16438C4.07502 7.2296 4.1185 7.28765 4.17271 7.33458L5.81771 8.84458Z" fill="#27AE60"/>
                                        </svg>
                                    <label class="form-check-label color-default font-weight-bold ">
                                      Migration Started Date
                                    </label>
                                  </div>
                                  <div class="col-md-6"> 
                                    <small v-if="lead.data_migration[index].schedule_at == null" class="badge badge-warning px-3 py-2 pull-right rounded-pill">{{lead.data_migration[index].expected_at | formatDemoDate}}</small>
                                    <small v-else-if="lead.data_migration[index].schedule_at != null" class="badge badge-success px-3 py-2 pull-right rounded-pill">{{lead.data_migration[index].schedule_at | formatDemoDate}}</small>
                                    <small v-else class="badge badge-success px-3 py-2 pull-right rounded-pill">------</small>
                                  </div>  
                                </div> 
                                <div v-show="data_migration_edit_status && lead.data_migration[index].schedule_for == null" class="row" >
                                  <div class="col-md-6">             
                                    <label>Starting Date</label>
                                  </div>
                                  <div class="col-md-6">
                                    <input v-model="onboarding.next_expected_date"
                                        :id="'schedule_at'+index+3" class="form-control" type="datetime-local" :min="lead.data_migration[index].expected_at || lead.data_migration[index].schedule_at"/>
                                    </div>
                                </div>
                                  <div v-show="data_migration_edit_status && lead.data_migration[index].schedule_for == null" class="row" >
                                    <div class="col-md-6">             
                                      <label>Delivery For</label>
                                    </div>
                                    <div class="col-md-6">
                                      <input v-model="onboarding.schedule_for"
                                        :id="'delivery_for'+index+3" class="form-control" type="datetime-local" :min="lead.data_migration[index].expected_at || lead.data_migration[index].schedule_at"/>
                                    </div>
                                  </div>  
                                  <div v-show="data_migration_edit_status && lead.data_migration[index].schedule_for == null" class="row pt-0">
                                    <div class="col-md-12">
                                      <label class="form-check-label" for="defaultCheck1">Comment </label><br />
                                          <input type="text" v-model="onboarding.schedule_comment" class="form-control"
                                          placeholder="Write Here"/>
                                    
                                    </div>  
                                  </div>
                                
                                <div class="row">
                                  <div class="col-md-6"> 
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="7" cy="7" r="6" fill="white" stroke="#27AE60"/>
                                          <path d="M5.81771 8.84458C5.93106 8.94545 6.07749 9.00117 6.22921 9.00117C6.38094 9.00117 6.52737 8.94545 6.64071 8.84458L9.83271 5.91258C9.88692 5.86565 9.9304 5.8076 9.96021 5.74238C9.99001 5.67716 10.0054 5.60629 10.0054 5.53458C10.0054 5.46288 9.99001 5.39201 9.96021 5.32679C9.9304 5.26157 9.88692 5.20352 9.83271 5.15658C9.71937 5.05572 9.57294 5 9.42121 5C9.26949 5 9.12306 5.05572 9.00971 5.15658L6.22971 7.70958L4.99571 6.57858C4.88257 6.47731 4.73606 6.42132 4.58421 6.42132C4.43237 6.42132 4.28586 6.47731 4.17271 6.57858C4.1185 6.62552 4.07502 6.68357 4.04522 6.74879C4.01542 6.81401 4 6.88488 4 6.95658C4 7.02829 4.01542 7.09916 4.04522 7.16438C4.07502 7.2296 4.1185 7.28765 4.17271 7.33458L5.81771 8.84458Z" fill="#27AE60"/>
                                        </svg>
                                    <label class="form-check-label color-default font-weight-bold ">
                                      Migration Completed Date
                                    </label>
                                  </div>
                                  <div  class="col-md-6"> 
                                    <small v-if="lead.data_migration[index].schedule_for && lead.data_migration[index].completed_at == null" class="badge badge-warning px-3 py-2 pull-right rounded-pill">{{lead.data_migration[index].schedule_for |formatDemoDate}} </small>
                                    <small v-else-if="lead.data_migration[index].completed_at != null" class="badge badge-success px-3 py-2 pull-right rounded-pill">{{lead.data_migration[index].completed_at |formatDemoDate}} </small>
                                    <small v-else class="badge badge-warning px-3 py-2 pull-right rounded-pill">------</small>
                                  </div>  
                                </div> 
                                <div v-if="data_migration_edit_status && lead.data_migration[index].schedule_for != null && lead.data_migration[index].status != 1" class="row">
                                  <div class="col-md-6">             
                                    <label>Is Completed</label>
                                  </div>
                                  <div class="col-md-6 text-right">
                                    <label class="switch">
                                      <input class="input-toggle" v-model="onboarding.is_completed" @click="onboarding.completed_at = (onboarding.completed_at != '') ? onboarding.completed_at:schDate;" type="checkbox">
                                      <span class="slider round"></span>
                                    </label>
                                  </div>
                                  </div>
                                  <div v-if="data_migration_edit_status && lead.data_migration[index].schedule_for != null && lead.data_migration[index].status != 1 && onboarding.is_completed == true" class="row">
                                  <div class="col-md-6"> 
                                    <label >
                                      Completed
                                    </label>
                                  </div>
                                  <div class="col-md-6">
                                      <input v-model="onboarding.completed_at"
                                        :id="'delivery_for'+index+3" class="form-control" type="datetime-local" />
                                  </div>
                                  </div>
                                  <div v-if="data_migration_edit_status && lead.data_migration[index].schedule_for != null && lead.data_migration[index].status != 1" class="row pt-0">
                                  <div class="col-md-12">
                                    <label class="form-check-label" for="defaultCheck1">Comment </label><br />
                                        <input type="text" v-model="onboarding.completed_comment" class="form-control"
                                        placeholder="Write Here"/>
                                      <br />
                                  </div>
                                </div>
                              </div>
                            </div>   
                        </div>
                      </div>
                    </div>
                    <div class="col-4" v-if="role_id != 5">
                      <div class="row">
                        <div class="col-sm-12 col-md-10 ">
                          <h5 class="font-weight-bolder pl-3 py-2" style="border-left: 3px solid #66B34D;">Training Session <small style="font-size: 60%;color: rgb(72, 166, 166);">{{ onboarding.timezone }}</small>
                          </h5>
                        </div>
                        <div v-if="lead.sessions.length > 0" class="col-sm-12 col-md-2 float-right">
                         
                          <div v-if="lead.sessions[lead.sessions.length-1].status != 0 && role_id != 2">
                            <button class="btn float-right" :disabled="lead.sessions[lead.sessions.length-1].status != 0 ? false : true" style="font-size: 24px;color: rgb(72, 166, 166);padding: 0px;" @click="addMore(lead,lead.id,lead.sessions[lead.sessions.length-1].lead_onboarding_id,lead.sessions[lead.sessions.length-1].stage,lead.org_id,'training'); add_more_session = true;"> <i class="fa fa-plus"></i></button>
                          </div>  
                        </div>
                      </div>
                      <div class="card card-body border-0" style="height: 355px; border-radius: 10px; overflow-y: auto;">
                        <div class="divScroll"
                          style="height:325px; overflow-y: auto;padding: 1.5rem 0rem; overflow-x:hidden;">
                          <div class="height:290px; overflow-y: auto; overflow-x:hidden; ">
                            <div>
                              <div v-show="lead.sessions.length == 0" class="container">
                                  <div class="row">
                                    <div class="col-md-6">
                                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.5 6C9.5 7.933 7.933 9.5 6 9.5C4.067 9.5 2.5 7.933 2.5 6C2.5 4.067 4.067 2.5 6 2.5C7.933 2.5 9.5 4.067 9.5 6Z" fill="white" stroke="#48A6A6"/>
                                        <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z" stroke="#48A6A6" stroke-width="2"/>
                                      </svg>
                                      <label class="font-weight-bold section-heading">Training Session 1</label>
                                    </div> 
                                  </div>
                                  <div class="row">
                                    <div class="col-md-6"> 
                                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="7" cy="7" r="6" fill="white" stroke="#27AE60"/>
                                        <path d="M5.81771 8.84458C5.93106 8.94545 6.07749 9.00117 6.22921 9.00117C6.38094 9.00117 6.52737 8.94545 6.64071 8.84458L9.83271 5.91258C9.88692 5.86565 9.9304 5.8076 9.96021 5.74238C9.99001 5.67716 10.0054 5.60629 10.0054 5.53458C10.0054 5.46288 9.99001 5.39201 9.96021 5.32679C9.9304 5.26157 9.88692 5.20352 9.83271 5.15658C9.71937 5.05572 9.57294 5 9.42121 5C9.26949 5 9.12306 5.05572 9.00971 5.15658L6.22971 7.70958L4.99571 6.57858C4.88257 6.47731 4.73606 6.42132 4.58421 6.42132C4.43237 6.42132 4.28586 6.47731 4.17271 6.57858C4.1185 6.62552 4.07502 6.68357 4.04522 6.74879C4.01542 6.81401 4 6.88488 4 6.95658C4 7.02829 4.01542 7.09916 4.04522 7.16438C4.07502 7.2296 4.1185 7.28765 4.17271 7.33458L5.81771 8.84458Z" fill="#27AE60"/>
                                      </svg>
                                      <label class="form-check-label color-default font-weight-bold ">
                                        Scheduled
                                      </label>
                                    </div>
                                    <div class="col-md-6"> 
                                      <small class="badge badge-warning px-3 py-2 pull-right rounded-pill">------</small>
                                    </div>  
                                  </div>
                                  <div class="row">
                                    <div class="col-md-6"> 
                                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="7" cy="7" r="6" fill="white" stroke="#27AE60"/>
                                        <path d="M5.81771 8.84458C5.93106 8.94545 6.07749 9.00117 6.22921 9.00117C6.38094 9.00117 6.52737 8.94545 6.64071 8.84458L9.83271 5.91258C9.88692 5.86565 9.9304 5.8076 9.96021 5.74238C9.99001 5.67716 10.0054 5.60629 10.0054 5.53458C10.0054 5.46288 9.99001 5.39201 9.96021 5.32679C9.9304 5.26157 9.88692 5.20352 9.83271 5.15658C9.71937 5.05572 9.57294 5 9.42121 5C9.26949 5 9.12306 5.05572 9.00971 5.15658L6.22971 7.70958L4.99571 6.57858C4.88257 6.47731 4.73606 6.42132 4.58421 6.42132C4.43237 6.42132 4.28586 6.47731 4.17271 6.57858C4.1185 6.62552 4.07502 6.68357 4.04522 6.74879C4.01542 6.81401 4 6.88488 4 6.95658C4 7.02829 4.01542 7.09916 4.04522 7.16438C4.07502 7.2296 4.1185 7.28765 4.17271 7.33458L5.81771 8.84458Z" fill="#27AE60"/>
                                      </svg>
                                      <label class="form-check-label color-default font-weight-bold ">
                                        Completed
                                      </label>
                                    </div>
                                    <div class="col-md-6"> 
                                      <small class="badge badge-warning px-3 py-2 pull-right rounded-pill">------</small>
                                    </div>  
                                  </div>
                                </div>
                              <div v-show="lead.sessions.length > 0" v-for="(value, index) in lead.sessions" :key="index">
                                <div class="container">
                                  <div class="row" >
                                    <div class="col-md-6">
                                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.5 6C9.5 7.933 7.933 9.5 6 9.5C4.067 9.5 2.5 7.933 2.5 6C2.5 4.067 4.067 2.5 6 2.5C7.933 2.5 9.5 4.067 9.5 6Z" fill="white" stroke="#48A6A6"/>
                                        <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z" stroke="#48A6A6" stroke-width="2"/>
                                      </svg>
                                      <label class="font-weight-bold section-heading">Training Session {{index+1}}</label>
                                    </div> 
                                    <div v-show="lead.sessions[index].status==0" class="col-md-6" style="display: flex; flex-direction:row-reverse;">
                                      <i :id="'training_save'+index" @click="save(3,index,lead.sessions[index])" class="fa fa-check-circle mr-1" style="font-size:19px;color:#48A6A6;display:none;order:1;"></i>
                                      <i :id="'training_cancel'+index" class="fa fa-times-circle" style="font-size:19px;color:#a70909;display:none;" @click="styleCancel('training',index);"></i>
                                      <span v-if="(role_id == 2 && index == 0 && lead.sessions[0].schedule_for == null) || role_id == 10 || role_id == 0 || role_id == 1 " :id="'training_edit'+index" @click="styleClass('training',index); 
                                      onboarding.id =  lead.sessions[index].id;
                                      onboarding.type = lead.sessions[index].stage;
                                      onboarding.status = lead.sessions[index].status;
                                      onboarding.lead_onboarding_id = lead.sessions[index].lead_onboarding_id;
                                      onboarding.schedule_for = lead.sessions[index].schedule_for ? lead.sessions[index].schedule_for : schDate;
                                      onboarding.schedule_comment = lead.sessions[index].schedule_comment;
                                      onboarding.schedule_at = (lead.sessions[index].schedule_at != null) ? lead.sessions[index].schedule_at : schDate;
                                      onboarding.is_completed = (lead.sessions[index].schedule_at != null && lead.sessions[index].status == 0) ? 1 : 0;
                                      onboarding.expected_at = lead.sessions[index].expected_at ; 
                                      onboarding.completed_comment = lead.sessions[index].completed_comment;
                                      onboarding.completed_at =  (lead.sessions[index].completed_at == null && lead.sessions[index].schedule_for == null)?'':lead.sessions[index].schedule_for;
                                      onboarding.stage_section = (lead.sessions[index].schedule_for != null) ? 'completed': 'started';
                                      add_more= (lead.sessions.length > 1)?  false :true;
                                      add_more_training_session = false;
                                      onboarding.zoom_meeting = false;
                                      onboarding.send_email_for_set_crendentials = (lead['org_status'] != 2)? true:false;
                                      onboarding.org_id = lead.org_id;
                                      onboarding.contact_emails= lead.email_list;
                                      onboarding.zoom_recording_link='';
                                      onboarding.passcode='';
                                      onboarding.org_current_time = lead.sessions[index].schedule_at != null ? getOrgTime(lead.timezone) : schDate;
                                      add_more_session = (lead.sessions[lead.sessions.length-1].status == 0 && lead.follow_ups.length>0) ? true : false;
                                      "
                                        class="fa fa-edit ml-1"
                                        style="cursor: pointer; color: #48A6A6">
                                        </span>
                                    </div>
                                  </div>
                                  <div  :id="'training_collapse'+index" >
                                    <div class="row">
                                      <div class="col-md-6"> 
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="7" cy="7" r="6" fill="white" stroke="#27AE60"/>
                                          <path d="M5.81771 8.84458C5.93106 8.94545 6.07749 9.00117 6.22921 9.00117C6.38094 9.00117 6.52737 8.94545 6.64071 8.84458L9.83271 5.91258C9.88692 5.86565 9.9304 5.8076 9.96021 5.74238C9.99001 5.67716 10.0054 5.60629 10.0054 5.53458C10.0054 5.46288 9.99001 5.39201 9.96021 5.32679C9.9304 5.26157 9.88692 5.20352 9.83271 5.15658C9.71937 5.05572 9.57294 5 9.42121 5C9.26949 5 9.12306 5.05572 9.00971 5.15658L6.22971 7.70958L4.99571 6.57858C4.88257 6.47731 4.73606 6.42132 4.58421 6.42132C4.43237 6.42132 4.28586 6.47731 4.17271 6.57858C4.1185 6.62552 4.07502 6.68357 4.04522 6.74879C4.01542 6.81401 4 6.88488 4 6.95658C4 7.02829 4.01542 7.09916 4.04522 7.16438C4.07502 7.2296 4.1185 7.28765 4.17271 7.33458L5.81771 8.84458Z" fill="#27AE60"/>
                                        </svg>
                                        <label class="form-check-label color-default font-weight-bold ">
                                          Scheduled 
                                        </label>
                                      </div>
                                      <div class="col-md-6"> 
                                        <small v-if="lead.sessions[index].expected_at  && lead.sessions[index].schedule_for == null" class="badge badge-warning px-3 py-2 pull-right rounded-pill">{{lead.sessions[index].expected_at |formatDemoDate}}</small>
                                        <small v-else-if="lead.sessions[index].schedule_for != null" class="badge badge-success px-3 py-2 pull-right rounded-pill">{{lead.sessions[index].schedule_at |formatDemoDate}}</small>
                                        <small v-else class="badge badge-warning px-3 py-2 pull-right rounded-pill">------</small>
                                      </div>  
                                    </div> 
                                    <div class="row"  v-if="(lead.sessions[index].completed_at != null && lead.sessions[index].status == 1)||(lead.sessions[index].completed_at == null && lead.sessions[index].status == 0)" >
                                      <div class="col-md-6" style="padding: 12px 12px 12px 12px !important;">
                                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="7" cy="7" r="6" fill="white" stroke="#27AE60"/>
                                        <path d="M5.81771 8.84458C5.93106 8.94545 6.07749 9.00117 6.22921 9.00117C6.38094 9.00117 6.52737 8.94545 6.64071 8.84458L9.83271 5.91258C9.88692 5.86565 9.9304 5.8076 9.96021 5.74238C9.99001 5.67716 10.0054 5.60629 10.0054 5.53458C10.0054 5.46288 9.99001 5.39201 9.96021 5.32679C9.9304 5.26157 9.88692 5.20352 9.83271 5.15658C9.71937 5.05572 9.57294 5 9.42121 5C9.26949 5 9.12306 5.05572 9.00971 5.15658L6.22971 7.70958L4.99571 6.57858C4.88257 6.47731 4.73606 6.42132 4.58421 6.42132C4.43237 6.42132 4.28586 6.47731 4.17271 6.57858C4.1185 6.62552 4.07502 6.68357 4.04522 6.74879C4.01542 6.81401 4 6.88488 4 6.95658C4 7.02829 4.01542 7.09916 4.04522 7.16438C4.07502 7.2296 4.1185 7.28765 4.17271 7.33458L5.81771 8.84458Z" fill="#27AE60"/>
                                      </svg>
                                        <label class="form-check-label color-default font-weight-bold ">
                                          Completed
                                        </label>
                                      </div>
                                      <div class="col-md-6" style="padding: 12px 12px 12px 12px !important;">
                                        <small v-if="lead.sessions[index].schedule_for != null && lead.sessions[index].completed_at == null" class="badge badge-warning px-3 py-2 pull-right rounded-pill">{{lead.sessions[index].schedule_for | formatDemoDate}}</small>
                                        <small v-else-if="lead.sessions[index].schedule_for != null && lead.sessions[index].completed_at != null" class="badge badge-success px-3 py-2 pull-right rounded-pill">{{lead.sessions[index].completed_at | formatDemoDate}}</small>
                                        <small v-else class="badge badge-warning px-3 py-2 pull-right rounded-pill">------</small>
                                      </div>
                                    </div>
                                    <div class="row" v-else>
                                      <div class="col-md-6" style="padding: 12px 12px 12px 12px !important;">
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="7" cy="7" r="6" stroke="#EB5757"/>
                                          <path d="M9 9L5 5M9 5L5 9" stroke="#EB5757" stroke-linecap="round"/>
                                        </svg>
                                        <label class="form-check-label color-default font-weight-bold " style="color:red !important;">
                                          Not Completed
                                        </label>
                                      </div>
                                      <div class="col-md-6" style="padding: 12px 12px 12px 12px !important;">
                                        <small v-if="lead.sessions[index].schedule_for != null && lead.sessions[index].completed_at == null" class="badge badge-warning px-3 py-2 pull-right rounded-pill">{{lead.sessions[index].schedule_for | formatDemoDate}}</small>
                                        <small v-if="lead.sessions[index].completed_at" class="badge badge-danger px-3 py-2 pull-right rounded-pill">{{lead.sessions[index].completed_at | formatDemoDate}}</small>
                                        <small v-else class="badge badge-danger px-3 py-2 pull-right rounded-pill">------</small>
                                      </div>
                                    </div>
                                  </div>
                                <div :id="'training_expand'+index" style="display:none;">
                                  <div class="row custom_margin_top">
                                    <div class="col-md-6" style="padding: 12px 12px 12px 12px !important;"> 
                                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="7" cy="7" r="6" fill="white" stroke="#27AE60"/>
                                        <path d="M5.81771 8.84458C5.93106 8.94545 6.07749 9.00117 6.22921 9.00117C6.38094 9.00117 6.52737 8.94545 6.64071 8.84458L9.83271 5.91258C9.88692 5.86565 9.9304 5.8076 9.96021 5.74238C9.99001 5.67716 10.0054 5.60629 10.0054 5.53458C10.0054 5.46288 9.99001 5.39201 9.96021 5.32679C9.9304 5.26157 9.88692 5.20352 9.83271 5.15658C9.71937 5.05572 9.57294 5 9.42121 5C9.26949 5 9.12306 5.05572 9.00971 5.15658L6.22971 7.70958L4.99571 6.57858C4.88257 6.47731 4.73606 6.42132 4.58421 6.42132C4.43237 6.42132 4.28586 6.47731 4.17271 6.57858C4.1185 6.62552 4.07502 6.68357 4.04522 6.74879C4.01542 6.81401 4 6.88488 4 6.95658C4 7.02829 4.01542 7.09916 4.04522 7.16438C4.07502 7.2296 4.1185 7.28765 4.17271 7.33458L5.81771 8.84458Z" fill="#27AE60"/>
                                      </svg>
                                      <label class="form-check-label color-default font-weight-bold ">
                                        Scheduled 
                                      </label>
                                    </div>
                                    <div class="col-md-6" style="padding: 12px 12px 12px 12px !important;"> 
                                      <small v-if="lead.sessions[index].expected_at  && lead.sessions[index].schedule_for == null" class="badge badge-warning px-3 py-2 pull-right rounded-pill">{{lead.sessions[index].expected_at |formatDemoDate}}</small>
                                      <small v-else-if="lead.sessions[index].schedule_for != null" class="badge badge-success px-3 py-2 pull-right rounded-pill">{{lead.sessions[index].schedule_at |formatDemoDate}}</small>
                                      <small v-else class="badge badge-warning px-3 py-2 pull-right rounded-pill">------</small>
                                    </div>  
                                  </div> 
                                  <div v-show="lead.sessions[index].status == 0 " class="row">
                                  </div>
                                  <div v-if="lead.sessions[index].schedule_for == null ||  (new Date(lead.sessions[index].schedule_for) >=  new Date(onboarding.org_current_time) && lead.sessions[index].schedule_for != null)" :style="[lead.sessions[index].schedule_for != null && training_session_edit_status ? {'margin-bottom':'12px !important'}:{'margin-bottom':'0px !important'}]" class="row py-2">
                                    <div class="col-md-6">             
                                      <label>Scheduled For </label>
                                    </div>
                                    <div class="col-md-6">
                                      <input v-if="lead.sessions[index].schedule_for == null" v-model="onboarding.schedule_for"
                                            :id="'expected_delivery'+index+3" class="form-control" type="datetime-local"  />
                                      <input v-else-if="lead.sessions[index].schedule_for != null &&  new Date(lead.sessions[index].schedule_for) >=  new Date(onboarding.org_current_time)" v-model="onboarding.schedule_for" 
                                            :id="'expected_delivery'+index+3" class="form-control" type="datetime-local"  />
                                      <small v-else class="badge badge-success px-3 py-2 pull-right rounded-pill">{{onboarding.schedule_for | formatDemoDate}}</small>
                                      <span class="schedules-list mt-3" @click="zoomModal">Schedule List</span>
                                      <!-- <small v-else class="badge badge-success px-3 py-2 pull-right rounded-pill">------</small> -->
                                    </div> 
                                
                                        <b-modal id="zoom_meetings"  :hide-footer="true" title="Schedule Meetings">
                                          <div class="zoom_meetings-content">
                                            <table class="table schedules-list">
                                              <thead>
                                                <tr>
                                                  <th>Meeting Topic</th>
                                                  <th>Eastern Time</th>
                                                  <th>Meeting Duration</th>
                                                </tr>
                                              </thead>
                                              <tbody v-show="meetingLoader">
                                                  <tr id="table_row">
                                                    <td colspan="16">
                                                      <b-skeleton-wrapper>
                                                        <b-skeleton height="40px"></b-skeleton>
                                                        <b-skeleton height="40px"></b-skeleton>
                                                      </b-skeleton-wrapper>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              <tbody v-show="!meetingLoader">
                                                <tr v-for="meeting in meetingsData" :key="meeting.uuid">
                                                  <td>{{ meeting.topic }}</td>
                                                  <td>{{ formattedStartTime(meeting.us_eastern_time) }}</td>
                                                  <td>{{ meeting.duration }}</td>
                                                </tr>
                                                <tr class="text-center" v-if="meetingsData.length<= 0"><td colspan="3"> No meeting Scheduled</td></tr>
                                              </tbody>

                                            </table>
                                            
                                          </div>
                                          <div class="text-right">
                                            <button type="button" class="btn btn-secondary mt-2" @click="$bvModal.hide('zoom_meetings')">
                                              Close
                                            </button>
                                          </div>
                                        </b-modal>
                                      <div v-if="lead.sessions[index].status == 0 && lead.sessions[index].schedule_for == null" class="col-md-12 send-link">
                                          <div class="col-md-6">             
                                            <label class="font-weight-bold">Send Zoom Meeting Link</label>
                                          </div>
                                          <div class="col-md-6 text-right">
                                            <label class="switch"  :style="[onboarding.contact_emails.length > 0? { 'pointer-events': 'auto !important' } : { 'pointer-events': 'none !important' }]" >
                                              <input class="input-toggle" v-model="onboarding.zoom_meeting" type="checkbox">
                                              <span class="slider round"></span>
                                            </label>
                                          </div>
                                      </div>  
                                      <div v-if="lead.sessions[index].status == 0 && lead.sessions[index].schedule_for == null && onboarding.zoom_meeting" class="col-md-12 send-link">
                                        <div class="col-md-6">             
                                          <label class="font-weight-bold">Contacts</label>
                                        </div>
                                        <div class="col-md-6 text-right">
                                          <label v-if="add_contact" class="color-default" @click="add_contacts">+ Add Contact
                                          </label>
                                        </div>
                                      </div>
                                      <div v-show="onboarding.contact_emails.length > 0  && onboarding.zoom_meeting" class="col-md-12 send-link" v-for="(val,ind) in onboarding.contact_emails" :key="ind">
                                        <div v-show="val != '' && lead.sessions[index].status == 0 && lead.sessions[index].schedule_for == null" :id="'display_contact'+index+ind" class="col-md-6"  >          
                                          <label>{{val}}</label>
                                        </div>
                                        <div v-show="val == '' &&  lead.sessions[index].status == 0 && lead.sessions[index].schedule_for == null" style="margin-top: -11px;"  :id="'add_contact'+index+ind" class="col-md-6"  >          
                                         <input :id="'email'+index+ind" v-model="email" type="text" class="form-control" />
                                        </div>
                                        <div v-show="lead.sessions[index].status == 0 && lead.sessions[index].schedule_for == null" class="col-md-6 text-right" style="display:flex; flex-direction:row-reverse;">
                                          <i  v-show="val == ''" :id="'save_contact'+index+ind" @click="saveContact(index,ind)" class="fa fa-check-circle mr-1" style="font-size:16px;color:#48A6A6;order:1;"></i>
                                          <i  v-show="val == ''" :id="'cancel_contact'+index+ind" class="fa fa-times-circle" style="font-size:16px;color:#a70909;" @click="cancelContact(index,ind);"></i>
                                          <svg v-show="val != ''" :id="'delete_contact'+index+ind" style="margin-left:2px" @click="popContact(index,ind);" class="training_svg email_action" width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2.33325 12.5C1.96659 12.5 1.65281 12.3696 1.39192 12.1087C1.13059 11.8473 0.999919 11.5333 0.999919 11.1667V2.5H0.333252V1.16667H3.66659V0.5H7.66659V1.16667H10.9999V2.5H10.3333V11.1667C10.3333 11.5333 10.2028 11.8473 9.94192 12.1087C9.68059 12.3696 9.36659 12.5 8.99992 12.5H2.33325ZM8.99992 2.5H2.33325V11.1667H8.99992V2.5ZM3.66659 9.83333H4.99992V3.83333H3.66659V9.83333ZM6.33325 9.83333H7.66659V3.83333H6.33325V9.83333Z" fill="#E34A24"/>
                                          </svg>
                                          <svg v-show="val != ''" @click="updateContact(index,ind)" :id="'update_contact'+index+ind" class="training_svg email_action" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.4373 0.5L12.3333 2.39593L10.8879 3.8419L8.99201 1.94597L10.4373 0.5ZM3.49316 9.34011H5.3891L9.99432 4.73489L8.09839 2.83895L3.49316 7.44418V9.34011Z" fill="#707070"/>
                                            <path d="M10.4449 11.236H3.593C3.57656 11.236 3.5595 11.2424 3.54307 11.2424C3.52221 11.2424 3.50136 11.2367 3.47987 11.236H1.59721V2.38835H5.92436L7.18832 1.12439H1.59721C0.900136 1.12439 0.333252 1.69064 0.333252 2.38835V11.236C0.333252 11.9337 0.900136 12.5 1.59721 12.5H10.4449C10.7801 12.5 11.1016 12.3668 11.3387 12.1298C11.5757 11.8928 11.7089 11.5713 11.7089 11.236V5.75805L10.4449 7.02201V11.236Z" fill="#707070"/>
                                          </svg>
                                          
                                        </div>
                                      </div>
                                    <div v-if="lead.sessions[index].schedule_for == null" class="col-md-12 pt-0">
                                          <label class="form-check-label" for="defaultCheck1">Comment </label><br />
                                              <input type="text" v-model="onboarding.schedule_comment" class="form-control"
                                              placeholder="Write Here"/>
                                    </div>   
                                    
                                  </div>
                                  
                                 
                                     
                                  
                                  <div class="row custom_margin_top" v-if="(onboarding.completed_at != null && onboarding.is_completed == true)||(onboarding.completed_at == '' && onboarding.is_completed == 0 )" :style="[lead.sessions[index].schedule_for != null && training_session_edit_status ? {'margin-top':'24px !important'}:{'margin-top':'0px !important'}]" >
                                    <div class="col-md-6"  style="padding: 12px 12px 12px 12px !important;"> 
                                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="7" cy="7" r="6" fill="white" stroke="#27AE60"/>
                                        <path d="M5.81771 8.84458C5.93106 8.94545 6.07749 9.00117 6.22921 9.00117C6.38094 9.00117 6.52737 8.94545 6.64071 8.84458L9.83271 5.91258C9.88692 5.86565 9.9304 5.8076 9.96021 5.74238C9.99001 5.67716 10.0054 5.60629 10.0054 5.53458C10.0054 5.46288 9.99001 5.39201 9.96021 5.32679C9.9304 5.26157 9.88692 5.20352 9.83271 5.15658C9.71937 5.05572 9.57294 5 9.42121 5C9.26949 5 9.12306 5.05572 9.00971 5.15658L6.22971 7.70958L4.99571 6.57858C4.88257 6.47731 4.73606 6.42132 4.58421 6.42132C4.43237 6.42132 4.28586 6.47731 4.17271 6.57858C4.1185 6.62552 4.07502 6.68357 4.04522 6.74879C4.01542 6.81401 4 6.88488 4 6.95658C4 7.02829 4.01542 7.09916 4.04522 7.16438C4.07502 7.2296 4.1185 7.28765 4.17271 7.33458L5.81771 8.84458Z" fill="#27AE60"/>
                                      </svg>
                                      <label class="form-check-label color-default font-weight-bold ">
                                        Completed
                                      </label>
                                    </div>
                                    <div class="col-md-6"  style="padding: 12px 12px 12px 12px !important;">
                                      <small v-if="onboarding.completed_at" class="badge badge-warning px-3 py-2 pull-right rounded-pill">{{onboarding.completed_at  | formatDemoDate}}</small>
                                      <small v-else class="badge badge-warning px-3 py-2 pull-right rounded-pill">------</small>
                                    </div>
                                  </div>
                                  <div class="row custom_margin_top" v-else :style="[lead.sessions[index].schedule_for != null && new Date(lead.sessions[index].schedule_for) < new Date(onboarding.org_current_time)  && training_session_edit_status ? {'margin-top':'24px !important'}:{'margin-top':'0px !important'}]">
                                    <div class="col-md-6" :style="[lead.sessions[index].schedule_for != null && new Date(lead.sessions[index].schedule_for) > today  && training_session_edit_status ? {'margin-top':'24px !important'}:{'margin-top':'0px !important'}]" style="padding: 12px 12px 12px 12px !important;">
                                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="7" cy="7" r="6" stroke="#EB5757"/>
                                        <path d="M9 9L5 5M9 5L5 9" stroke="#EB5757" stroke-linecap="round"/>
                                      </svg>
                                      <label class="form-check-label color-default font-weight-bold " style="color:red !important;">
                                        Not Completed
                                      </label>
                                    </div>
                                    <div class="col-md-6" :style="[lead.sessions[index].schedule_for != null && new Date(lead.sessions[index].schedule_for) > new Date(onboarding.org_current_time)  && training_session_edit_status ? {'margin-top':'24px !important'}:{'margin-top':'0px !important'}]" style="padding: 12px 12px 12px 12px !important;">
                                      <small v-if="onboarding.completed_at " class="badge badge-danger px-3 py-2 pull-right rounded-pill">{{onboarding.completed_at | formatDemoDate}}</small>
                                      <small v-else class="badge badge-danger px-3 py-2 pull-right rounded-pill">------</small>
                                    </div>
                                  </div>
                                  <div v-show="lead.sessions[index].schedule_for != null && new Date(lead.sessions[index].schedule_for) < new Date(onboarding.org_current_time)" class="row">
                                      <div class="col-md-6">             
                                        <label>Is Completed</label>
                                      </div>
                                      <div class="col-md-6 text-right">
                                        <label class="switch">
                                          <input class="input-toggle" v-model="onboarding.is_completed"
                                           @click="onboarding.completed_at =  (onboarding.completed_at != '') ? onboarding.completed_at:schDate;onboarding.next_expected_date =(onboarding.next_expected_date=='')?schDate:onboarding.next_expected_date; setOrgStatus(lead['org_status']);" type="checkbox">
                                          <span class="slider round"></span>
                                        </label>
                                      </div>
                                  </div>
                                  <div v-show="lead.sessions[index].schedule_for != null && new Date(lead.sessions[index].schedule_for) < new Date(onboarding.org_current_time)" class="row">
                                    <div class="col-md-6"> 
                                      <label>
                                        Completed
                                      </label>
                                    </div>
                                    <div class="col-md-6">
                                        <input v-model="onboarding.completed_at" class="form-control" type="datetime-local" />
                                    </div>  
                                  </div>
                                      <div v-show="lead.sessions[index].schedule_for != null && new Date(lead.sessions[index].schedule_for) < new Date(onboarding.org_current_time)" class="row pt-0">
                                        <div class="col-md-12">
                                          <label class="form-check-label" for="defaultCheck1">Comment </label><br />
                                              <input type="text" v-model="onboarding.completed_comment" class="form-control"
                                              placeholder="Write Here"/>
                                        
                                        </div>  
                                      </div>
                                      <div v-show="lead.sessions[index].schedule_for != null && lead.org_status != 2 && new Date(lead.sessions[index].schedule_for) < new Date(onboarding.org_current_time)" class="row">
                                        <div class="col-md-6">             
                                          <label >Start Organization Trial</label>
                                        </div>
                                        <div class="col-md-6 text-right" :style="[onboarding.is_completed == false ? { 'pointer-events': 'none !important' } : { 'pointer-events': 'auto !important' }]" >
                                          <label class="switch" >
                                            <input class="input-toggle" v-model="onboarding.send_email_for_set_crendentials"  type="checkbox">
                                            <span class="slider round"></span>
                                          </label>
                                        </div>
                                      </div>
                                      <div v-show="lead.sessions[index].schedule_for != null && lead.org_status != 2 && new Date(lead.sessions[index].schedule_for) < new Date(onboarding.org_current_time)" class="row pt-0">
                                        <div class="col-md-12">
                                          <label class="form-check-label" for="defaultCheck1">Zoom Recording Link</label><br />
                                              <input type="text" v-model="onboarding.zoom_recording_link" class="form-control"
                                              placeholder="Zoom Recording Link"/>
                                        
                                        </div>  
                                      </div>
                                      <div v-show="lead.sessions[index].schedule_for != null && lead.org_status != 2 && new Date(lead.sessions[index].schedule_for) < new Date(onboarding.org_current_time)" class="row pt-0">
                                        <div class="col-md-12">
                                          <label class="form-check-label" for="defaultCheck1">Passcode</label><br />
                                              <input type="text" v-model="onboarding.passcode" class="form-control"
                                              placeholder="Passcode"/>
                                        
                                        </div>  
                                      </div>
                                      <div v-show="lead.sessions[index].schedule_for != null && !add_more_session && new Date(lead.sessions[index].schedule_for) < new Date(onboarding.org_current_time)" class="row">
                                        <div class="col-md-6">             
                                          <label >Need another training session</label>
                                        </div>
                                        <div class="col-md-6 text-right">
                                          <label class="switch" :style="[(lead.sessions.length >= 2 && onboarding.is_completed != false) ? {'pointer-events':'auto'}:{'pointer-events':'none'}]">
                                            <input class="input-toggle" v-model="add_more" @click="onboarding.next_expected_date =schDate;"  type="checkbox">
                                            <span class="slider round"></span>
                                          </label>
                                        </div>
                                      </div>
                                      <div v-show="lead.sessions[index].schedule_for != null && !add_more_session && new Date(lead.sessions[index].schedule_for) < new Date(onboarding.org_current_time)" class="row">
                                        <div class="col-md-6">             
                                          <label v-if="add_more">Set Training Date</label>
                                          <label v-else>Set FollowUp Date</label>
                                        </div>
                                        <div class="col-md-6">
                                          <input v-model="onboarding.next_expected_date"
                                          :id="'delivery_for'+index+3" class="form-control" type="datetime-local" />
                                        </div>
                                      </div>
                                </div>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                    </div>
                    <div class="col-4" v-if="role_id != 5">
                      <div class="row">
                        <div class="col-sm-12 col-md-10 ">
                          <h5 class="font-weight-bolder pl-3 py-2" style="border-left: 3px solid rgb(231, 91, 72);">Followup
                          </h5>
                        </div>
                        <div v-if="lead.follow_ups.length > 0" class="col-sm-12 col-md-2 float-right">
                          <div v-if="lead.follow_ups[lead.follow_ups.length-1].status != 0 && role_id != 2" >
                            <button class="btn float-right" :disabled="lead.follow_ups[lead.follow_ups.length-1].status != 0 ? false : true" style="font-size: 24px;color: rgb(72, 166, 166);padding: 0px;" @click="addMore(lead,lead.id,lead.follow_ups[lead.follow_ups.length-1].lead_onboarding_id,lead.follow_ups[lead.follow_ups.length-1].stage,lead.org_id,'followup');"> <i class="fa fa-plus"></i></button>
                          </div>
                        </div>
                      </div>
                      <div class="card card-body border-0" style="height: 355px; border-radius: 10px; overflow-y: auto;">
                        <div class="divScroll"
                          style="height:325px; overflow-y: auto;padding: 1.5rem 0rem; overflow-x:hidden;">
                          <div class="height:290px; overflow-y: auto; overflow-x:hidden; ">
                            <div>
                              <div v-show="lead.follow_ups.length == 0" class="container">
                                  <div class="row">
                                    <div class="col-md-6">
                                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.5 6C9.5 7.933 7.933 9.5 6 9.5C4.067 9.5 2.5 7.933 2.5 6C2.5 4.067 4.067 2.5 6 2.5C7.933 2.5 9.5 4.067 9.5 6Z" fill="white" stroke="#48A6A6"/>
                                        <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z" stroke="#48A6A6" stroke-width="2"/>
                                      </svg>
                                      <label class="font-weight-bold section-heading">Followup 1</label>
                                    </div> 
                                  </div>
                                  <div class="row">
                                    <div class="col-md-6"> 
                                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="7" cy="7" r="6" fill="white" stroke="#27AE60"/>
                                        <path d="M5.81771 8.84458C5.93106 8.94545 6.07749 9.00117 6.22921 9.00117C6.38094 9.00117 6.52737 8.94545 6.64071 8.84458L9.83271 5.91258C9.88692 5.86565 9.9304 5.8076 9.96021 5.74238C9.99001 5.67716 10.0054 5.60629 10.0054 5.53458C10.0054 5.46288 9.99001 5.39201 9.96021 5.32679C9.9304 5.26157 9.88692 5.20352 9.83271 5.15658C9.71937 5.05572 9.57294 5 9.42121 5C9.26949 5 9.12306 5.05572 9.00971 5.15658L6.22971 7.70958L4.99571 6.57858C4.88257 6.47731 4.73606 6.42132 4.58421 6.42132C4.43237 6.42132 4.28586 6.47731 4.17271 6.57858C4.1185 6.62552 4.07502 6.68357 4.04522 6.74879C4.01542 6.81401 4 6.88488 4 6.95658C4 7.02829 4.01542 7.09916 4.04522 7.16438C4.07502 7.2296 4.1185 7.28765 4.17271 7.33458L5.81771 8.84458Z" fill="#27AE60"/>
                                      </svg>
                                      <label class="form-check-label color-default font-weight-bold ">
                                        Scheduled
                                      </label>
                                    </div>
                                    <div class="col-md-6"> 
                                      <small class="badge badge-warning px-3 py-2 pull-right rounded-pill">------</small>
                                    </div>  
                                  </div>
                                  <div class="row">
                                    <div class="col-md-6"> 
                                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="7" cy="7" r="6" fill="white" stroke="#27AE60"/>
                                        <path d="M5.81771 8.84458C5.93106 8.94545 6.07749 9.00117 6.22921 9.00117C6.38094 9.00117 6.52737 8.94545 6.64071 8.84458L9.83271 5.91258C9.88692 5.86565 9.9304 5.8076 9.96021 5.74238C9.99001 5.67716 10.0054 5.60629 10.0054 5.53458C10.0054 5.46288 9.99001 5.39201 9.96021 5.32679C9.9304 5.26157 9.88692 5.20352 9.83271 5.15658C9.71937 5.05572 9.57294 5 9.42121 5C9.26949 5 9.12306 5.05572 9.00971 5.15658L6.22971 7.70958L4.99571 6.57858C4.88257 6.47731 4.73606 6.42132 4.58421 6.42132C4.43237 6.42132 4.28586 6.47731 4.17271 6.57858C4.1185 6.62552 4.07502 6.68357 4.04522 6.74879C4.01542 6.81401 4 6.88488 4 6.95658C4 7.02829 4.01542 7.09916 4.04522 7.16438C4.07502 7.2296 4.1185 7.28765 4.17271 7.33458L5.81771 8.84458Z" fill="#27AE60"/>
                                      </svg>
                                      <label class="form-check-label color-default font-weight-bold ">
                                        Completed
                                      </label>
                                    </div>
                                    <div class="col-md-6"> 
                                      <small class="badge badge-warning px-3 py-2 pull-right rounded-pill">------</small>
                                    </div>  
                                  </div>
                                </div>
                              <div v-show="lead.follow_ups.length > 0" v-for="(value, index) in lead.follow_ups" :key="index">
                                <div class="container">
                                  <div class="row">
                                    <div class="col-md-6">
                                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.5 6C9.5 7.933 7.933 9.5 6 9.5C4.067 9.5 2.5 7.933 2.5 6C2.5 4.067 4.067 2.5 6 2.5C7.933 2.5 9.5 4.067 9.5 6Z" fill="white" stroke="#48A6A6"/>
                                        <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z" stroke="#48A6A6" stroke-width="2"/>
                                      </svg>
                                      <label class="font-weight-bold section-heading">Followup {{index+1}}</label>
                                    </div> 
                                    <div v-show="lead.follow_ups[index].status==0 && role_id != 2" class="col-md-6" style="display: flex; flex-direction:row-reverse;">                                    
                                      <i :id="'followup_save'+index" @click="save(4,index,lead.follow_ups[index])" class="fa fa-check-circle mr-1" style="font-size:19px;color:#48A6A6;display:none;order:1;"></i>
                                      <i :id="'followup_cancel'+index" class="fa fa-times-circle" style="font-size:19px;color:#a70909;display:none;" @click="styleCancel('followup',index);"></i>
                                      <span v-if="lead.sessions[lead.sessions.length-1].status != 0" :id="'followup_edit'+index" @click="styleClass('followup',index);
                                      onboarding.id =  lead.follow_ups[index].id;
                                      onboarding.type = lead.follow_ups[index].stage;
                                      onboarding.status = lead.follow_ups[index].status;
                                      onboarding.lead_onboarding_id = lead.follow_ups[index].lead_onboarding_id;
                                      onboarding.schedule_for = lead.follow_ups[index].schedule_for ? lead.follow_ups[index].schedule_for : schDate;
                                      onboarding.schedule_comment = lead.follow_ups[index].schedule_comment;
                                      onboarding.schedule_at =  (lead.follow_ups[index].schedule_at != null) ? lead.follow_ups[index].schedule_at : schDate;
                                      onboarding.is_completed = (lead.follow_ups[index].schedule_at != null && lead.follow_ups[index].status == 0) ? 1 : 0;
                                      onboarding.expected_at = lead.follow_ups[index].expected_at ; 
                                      onboarding.completed_comment = lead.follow_ups[index].completed_comment;
                                      onboarding.completed_at = (lead.follow_ups[index].completed_at == null && lead.follow_ups[index].schedule_for == null)?'':lead.follow_ups[index].schedule_for;
                                      onboarding.stage_section = (lead.follow_ups[index].schedule_for != null) ? 'completed': 'started';
                                      add_more = true;
                                      add_more_training_session = false;
                                      onboarding.zoom_meeting = false;
                                      onboarding.org_id = lead.org_id;
                                      "
                                        class="fa fa-edit ml-1"
                                        style="cursor: pointer; color: #48A6A6">
                                        </span>
                                    </div>
                                  </div>
                                  <div  :id="'followup_collapse'+index" >
                                    <div class="row">
                                      <div class="col-md-6"> 
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="7" cy="7" r="6" fill="white" stroke="#27AE60"/>
                                          <path d="M5.81771 8.84458C5.93106 8.94545 6.07749 9.00117 6.22921 9.00117C6.38094 9.00117 6.52737 8.94545 6.64071 8.84458L9.83271 5.91258C9.88692 5.86565 9.9304 5.8076 9.96021 5.74238C9.99001 5.67716 10.0054 5.60629 10.0054 5.53458C10.0054 5.46288 9.99001 5.39201 9.96021 5.32679C9.9304 5.26157 9.88692 5.20352 9.83271 5.15658C9.71937 5.05572 9.57294 5 9.42121 5C9.26949 5 9.12306 5.05572 9.00971 5.15658L6.22971 7.70958L4.99571 6.57858C4.88257 6.47731 4.73606 6.42132 4.58421 6.42132C4.43237 6.42132 4.28586 6.47731 4.17271 6.57858C4.1185 6.62552 4.07502 6.68357 4.04522 6.74879C4.01542 6.81401 4 6.88488 4 6.95658C4 7.02829 4.01542 7.09916 4.04522 7.16438C4.07502 7.2296 4.1185 7.28765 4.17271 7.33458L5.81771 8.84458Z" fill="#27AE60"/>
                                        </svg>
                                        <label class="form-check-label color-default font-weight-bold ">
                                          Scheduled
                                        </label>
                                      </div>
                                      <div class="col-md-6"> 
                                        <small v-if="lead.follow_ups[index].expected_at  && lead.follow_ups[index].schedule_for == null" class="badge badge-warning px-3 py-2 pull-right rounded-pill">{{lead.follow_ups[index].expected_at |formatDemoDate}}</small>
                                        <small v-else-if="lead.follow_ups[index].schedule_for != null" class="badge badge-success px-3 py-2 pull-right rounded-pill">{{lead.follow_ups[index].schedule_at |formatDemoDate}}</small>
                                        <small v-else class="badge badge-warning px-3 py-2 pull-right rounded-pill">------</small>
                                      </div>  
                                    </div> 
                                    <div class="row"  v-if="(lead.follow_ups[index].completed_at != null && lead.follow_ups[index].status == 1)||(lead.follow_ups[index].completed_at == null && lead.follow_ups[index].status == 0)" >
                                      <div class="col-md-6" style="padding: 12px 12px 12px 12px !important;">
                                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="7" cy="7" r="6" fill="white" stroke="#27AE60"/>
                                        <path d="M5.81771 8.84458C5.93106 8.94545 6.07749 9.00117 6.22921 9.00117C6.38094 9.00117 6.52737 8.94545 6.64071 8.84458L9.83271 5.91258C9.88692 5.86565 9.9304 5.8076 9.96021 5.74238C9.99001 5.67716 10.0054 5.60629 10.0054 5.53458C10.0054 5.46288 9.99001 5.39201 9.96021 5.32679C9.9304 5.26157 9.88692 5.20352 9.83271 5.15658C9.71937 5.05572 9.57294 5 9.42121 5C9.26949 5 9.12306 5.05572 9.00971 5.15658L6.22971 7.70958L4.99571 6.57858C4.88257 6.47731 4.73606 6.42132 4.58421 6.42132C4.43237 6.42132 4.28586 6.47731 4.17271 6.57858C4.1185 6.62552 4.07502 6.68357 4.04522 6.74879C4.01542 6.81401 4 6.88488 4 6.95658C4 7.02829 4.01542 7.09916 4.04522 7.16438C4.07502 7.2296 4.1185 7.28765 4.17271 7.33458L5.81771 8.84458Z" fill="#27AE60"/>
                                      </svg>
                                        <label class="form-check-label color-default font-weight-bold ">
                                          Completed
                                        </label>
                                      </div>
                                      <div class="col-md-6" style="padding: 12px 12px 12px 12px !important;">
                                        <small v-if="lead.follow_ups[index].schedule_for  && lead.follow_ups[index].completed_at == null" class="badge badge-warning px-3 py-2 pull-right rounded-pill">{{lead.follow_ups[index].schedule_for |formatDemoDate}}</small>
                                        <small v-else-if="lead.follow_ups[index].schedule_for && lead.follow_ups[index].completed_at" class="badge badge-success px-3 py-2 pull-right rounded-pill">{{lead.follow_ups[index].completed_at | formatDemoDate}}</small>
                                        <small v-else class="badge badge-warning px-3 py-2 pull-right rounded-pill">------</small>
                                      </div>
                                    </div>
                                    <div class="row" v-else>
                                      <div class="col-md-6" style="padding: 12px 12px 12px 12px !important;">
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="7" cy="7" r="6" stroke="#EB5757"/>
                                          <path d="M9 9L5 5M9 5L5 9" stroke="#EB5757" stroke-linecap="round"/>
                                        </svg>
                                        <label class="form-check-label color-default font-weight-bold " style="color:red !important;">
                                          Not Completed
                                        </label>
                                      </div>
                                      <div class="col-md-6" style="padding: 12px 12px 12px 12px !important;">
                                        <small v-if="lead.follow_ups[index].schedule_for  && lead.follow_ups[index].completed_at == null" class="badge badge-warning px-3 py-2 pull-right rounded-pill">{{lead.follow_ups[index].schedule_for |formatDemoDate}}</small>
                                        <small v-else-if="lead.follow_ups[index].schedule_for  && lead.follow_ups[index].completed_at" class="badge badge-danger px-3 py-2 pull-right rounded-pill">{{lead.follow_ups[index].completed_at | formatDemoDate}}</small>
                                        <small v-else class="badge badge-danger px-3 py-2 pull-right rounded-pill">------</small>
                                      </div>
                                    </div>
                                  </div>
                                <div :id="'followup_expand'+index" style="display:none;">
                                  <div class="row">
                                    <div class="col-md-6"> 
                                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="7" cy="7" r="6" fill="white" stroke="#27AE60"/>
                                        <path d="M5.81771 8.84458C5.93106 8.94545 6.07749 9.00117 6.22921 9.00117C6.38094 9.00117 6.52737 8.94545 6.64071 8.84458L9.83271 5.91258C9.88692 5.86565 9.9304 5.8076 9.96021 5.74238C9.99001 5.67716 10.0054 5.60629 10.0054 5.53458C10.0054 5.46288 9.99001 5.39201 9.96021 5.32679C9.9304 5.26157 9.88692 5.20352 9.83271 5.15658C9.71937 5.05572 9.57294 5 9.42121 5C9.26949 5 9.12306 5.05572 9.00971 5.15658L6.22971 7.70958L4.99571 6.57858C4.88257 6.47731 4.73606 6.42132 4.58421 6.42132C4.43237 6.42132 4.28586 6.47731 4.17271 6.57858C4.1185 6.62552 4.07502 6.68357 4.04522 6.74879C4.01542 6.81401 4 6.88488 4 6.95658C4 7.02829 4.01542 7.09916 4.04522 7.16438C4.07502 7.2296 4.1185 7.28765 4.17271 7.33458L5.81771 8.84458Z" fill="#27AE60"/>
                                      </svg>
                                      <label class="form-check-label color-default font-weight-bold ">
                                        Scheduled
                                      </label>
                                    </div>
                                    <div class="col-md-6"> 
                                      <small v-if="lead.follow_ups[index].expected_at  && lead.follow_ups[index].schedule_for == null" class="badge badge-warning px-3 py-2 pull-right rounded-pill">{{lead.follow_ups[index].expected_at |formatDemoDate}}</small>
                                        <small v-else-if="lead.follow_ups[index].schedule_for != null" class="badge badge-success px-3 py-2 pull-right rounded-pill">{{lead.follow_ups[index].schedule_at |formatDemoDate}}</small>
                                      <small v-else class="badge badge-warning px-3 py-2 pull-right rounded-pill">------</small>
                                    </div>  
                                  </div>
                                  <div v-if="lead.follow_ups[index].schedule_for == null" class="row">
                                    <div class="col-md-6">             
                                      <label>Scheduled For</label>
                                    </div>
                                    <div class="col-md-6">
                                      <input v-if="lead.follow_ups[index].schedule_for == null" v-model="onboarding.schedule_for" 
                                            class="form-control" type="datetime-local"  />
                                      <!-- <input v-else-if="lead.follow_ups[index].schedule_for != null &&  new Date(lead.follow_ups[index].schedule_for) >=  today" v-model="onboarding.schedule_for" 
                                            class="form-control" type="datetime-local"  /> -->
                                      <small v-else class="badge badge-success px-3 py-2 pull-right rounded-pill">{{onboarding.schedule_for | formatDemoDate}}</small>
                                    </div> 
                                    <div v-if="lead.follow_ups[index].schedule_for == null" class="col-md-12 pt-0">
                                          <label class="form-check-label" for="defaultCheck1">Comment </label><br />
                                              <input type="text" v-model="onboarding.schedule_comment" class="form-control"
                                              placeholder="Write Here"/>
                                        
                                        </div>   
                                  </div>
                                
                                  <div class="row" v-if="(onboarding.completed_at != null && onboarding.is_completed == 1)||(onboarding.completed_at == '' && onboarding.is_completed == 0 )" >
                                    <div class="col-md-6" style="padding: 12px 12px 12px 12px !important;"> 
                                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="7" cy="7" r="6" fill="white" stroke="#27AE60"/>
                                        <path d="M5.81771 8.84458C5.93106 8.94545 6.07749 9.00117 6.22921 9.00117C6.38094 9.00117 6.52737 8.94545 6.64071 8.84458L9.83271 5.91258C9.88692 5.86565 9.9304 5.8076 9.96021 5.74238C9.99001 5.67716 10.0054 5.60629 10.0054 5.53458C10.0054 5.46288 9.99001 5.39201 9.96021 5.32679C9.9304 5.26157 9.88692 5.20352 9.83271 5.15658C9.71937 5.05572 9.57294 5 9.42121 5C9.26949 5 9.12306 5.05572 9.00971 5.15658L6.22971 7.70958L4.99571 6.57858C4.88257 6.47731 4.73606 6.42132 4.58421 6.42132C4.43237 6.42132 4.28586 6.47731 4.17271 6.57858C4.1185 6.62552 4.07502 6.68357 4.04522 6.74879C4.01542 6.81401 4 6.88488 4 6.95658C4 7.02829 4.01542 7.09916 4.04522 7.16438C4.07502 7.2296 4.1185 7.28765 4.17271 7.33458L5.81771 8.84458Z" fill="#27AE60"/>
                                      </svg>
                                      <label class="form-check-label color-default font-weight-bold ">
                                        Completed 
                                      </label>
                                    </div>
                                    <div class="col-md-6" style="padding: 12px 12px 12px 12px !important;">
                                      <small v-if="onboarding.completed_at " class="badge badge-warning px-3 py-2 pull-right rounded-pill">{{onboarding.completed_at  | formatDemoDate}}</small>
                                      <small v-else class="badge badge-warning px-3 py-2 pull-right rounded-pill">------</small>
                                    </div>
                                  </div>
                                  <div class="row" v-else>
                                    <div class="col-md-6" style="padding: 12px 12px 12px 12px !important;">
                                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="7" cy="7" r="6" stroke="#EB5757"/>
                                        <path d="M9 9L5 5M9 5L5 9" stroke="#EB5757" stroke-linecap="round"/>
                                      </svg>
                                      <label class="form-check-label color-default font-weight-bold " style="color:red !important;">
                                        Not Completed
                                      </label>
                                    </div>
                                    <div class="col-md-6" style="padding: 12px 12px 12px 12px !important;">
                                      <small v-if="onboarding.completed_at " class="badge badge-danger px-3 py-2 pull-right rounded-pill">{{onboarding.completed_at | formatDemoDate}}</small>
                                      <small v-else class="badge badge-danger px-3 py-2 pull-right rounded-pill">------</small>
                                    </div>
                                  </div>
                                  <div v-show="lead.follow_ups[index].schedule_for != null" class="row">
                                      <div class="col-md-6">             
                                        <label>Is Completed</label>
                                      </div>
                                      <div class="col-md-6 text-right">
                                        <label class="switch">
                                          <input class="input-toggle" v-model="onboarding.is_completed" @click="onboarding.completed_at =  (onboarding.completed_at != '') ? onboarding.completed_at:schDate;onboarding.next_expected_date =(onboarding.next_expected_date=='')?schDate:onboarding.next_expected_date;" type="checkbox">
                                          <span class="slider round"></span>
                                        </label>
                                      </div>
                                  </div>
                                  <div v-show="lead.follow_ups[index].schedule_for != null" class="row">
                                    <div class="col-md-6"> 
                                      <label >
                                        Completed
                                      </label>
                                    </div>
                                    <div class="col-md-6">
                                        <input v-model="onboarding.completed_at" class="form-control" type="datetime-local" />
                                    </div>  
                                  </div>
                                      <div v-show="lead.follow_ups[index].schedule_for != null" class="row pt-0">
                                        <div class="col-md-12">
                                          <label class="form-check-label" for="defaultCheck1">Comment </label><br />
                                              <input type="text" v-model="onboarding.completed_comment" class="form-control"
                                              placeholder="Write Here"/>
                                        
                                        </div>  
                                      </div>
                                      <div v-show="lead.follow_ups[index].schedule_for != null" class="row">
                                        <div class="col-md-6">             
                                          <label>Need another Training Session</label>
                                        </div>
                                        <div class="col-md-6 text-right">
                                          <label class="switch">
                                            <input class="input-toggle" v-model="add_more_training_session" @click="addFollowup"  type="checkbox">
                                            <span class="slider round"></span>
                                          </label>
                                        </div>
                                      </div>
                                      <div v-show="lead.follow_ups[index].schedule_for != null  && add_more_training_session" class="row">
                                        <div class="col-md-6">             
                                          <label>Set Training Date</label>
                                        </div>
                                        <div class="col-md-6">
                                          <input v-model="onboarding.next_expected_date" class="form-control" type="datetime-local" />
                                        </div>
                                      </div>
                                   
                                      <div v-show="lead.follow_ups[index].schedule_for != null && !add_more_training_session" class="row">
                                        <div class="col-md-6">             
                                          <label>Need another Followup</label>
                                        </div>
                                        <div class="col-md-6 text-right">
                                          <label class="switch">
                                            <input class="input-toggle" v-model="add_more" @click="onboarding.next_expected_date = (onboarding.next_expected_date=='')?schDate:onboarding.next_expected_date;"  type="checkbox">
                                            <span class="slider round"></span>
                                          </label>
                                        </div>
                                      </div>
                                      <div v-show="lead.follow_ups[index].schedule_for != null && !add_more_training_session && add_more" class="row">
                                        <div class="col-md-6">             
                                          <label>Set FollowUp Date</label>
                                        </div>
                                        <div class="col-md-6">
                                          <input v-model="onboarding.next_expected_date" class="form-control" type="datetime-local" />
                                        </div>
                                      </div>
                                    </div>
                               </div>
                               </div>
                            </div>
                          </div>
                      </div>
                    </div>
                    </div>
                  </div>
                </td>
              </tr>
            </transition>
          </tbody>
          <tr v-if="demoLeads == '' && !isLoader" class="not-found-height" style="height: 30vh">
            <td colspan="13">
              <h6 class="text-center">No Data Found!</h6>
            </td>
          </tr>
        </table>
        <popup v-show="isVisible" :attachments="attachment" :aws_base_path="aws_base_path" @setVisibility="setVisibility" />
        <!-- Pagination  -->
        <div v-if="!isLoader" class="container border-top" style="font-size: 14px; bottom: 0">
          <div class="row mt-1 justify-content-end d-flex align-items-center px-3">
            <div class="pt-0">
              <span class="pr-3 font-weight-light">Total Records</span>
              <span class="
                        pr-5
                        color-default
                        text-decoration-underline
                        font-weight-bold
                      ">{{ totalLeads }}</span>
              <span class="pr-3 font-weight-light">Display Rows</span><span class="
                        pr-5
                        mr-3
                        color-default
                        font-weight-bold
                        text-decoration-underline
                      ">{{ totalRows }}</span>
            </div>
            <paginate v-model="currentPage" :page-count="totalPages" :click-handler="setPage" :prev-text="''"
              :next-text="''" :first-button-text="''" :last-button-text="''" :first-last-button="true"
              :container-class="'pagination pagination-sm mb-0'" :page-class="'page-item'" :prev-class="'page-item prev'"
              :next-class="'page-item next'" :page-link-class="'page-link'" :prev-link-class="'page-link'"
              :next-link-class="'page-link'"></paginate>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import helpers from "@/helpers.js";
import VueSkeletonLoader from 'skeleton-loader-vue';
import boardingForm from "./onboarding_form.vue";
import { ref } from 'vue';
import popup from './pop_up.vue';
import trialDateForm from "./../organizations/trial_date_form.vue";
Vue.filter("formatDemoDate", function (value) {
  if (value != "0000-00-00" && value != null) {
    return moment(String(value)).format("DD MMM,Y h:mm a");
  }
});
Vue.filter("formatDate", function (value) {
  if (value != "0000-00-00" && value != null) {
    return moment(String(value)).format("MMM DD,Y h:mm a");
  }
});
export default {
  components: {
    VueSkeletonLoader,popup
  },
  data() {
    return {
      isEditing: false,
      receiveDate: '',
      meetingsData: [],
      already_schedule : false,
      selectTab: 0,
      page: 0,
      row_id: -1,
      total_session: 0,
      is_migrate: false,
      is_end: false,
      is_end1: false,
      is_demo: false,
      demo: false,
      demoCmp: false,
      demoOne: false,
      demoOneCmp: false,
      demo1: false,
      demo2: false,
      demo_edit: false,
      demoOne_edit: false,
      demoCmp_edit: false,
      demoOneCmp_edit: false,
      demo_edit1: false,
      demo_edit2: false,
      is_checked: false,
      is_complete: false,
      is_complete1: false,
      is_complete2: false,
      rec_checked: false,
      UpHere: false,
      edit: false,
      rec_edit: false,
      recieve: false,
      schedulecmp_edit: false,
      schedule_edit: false,
      scheduled_edit: false,
      scheduleCmp: false,
      schedule: false,
      is_schedule: false,
      schDate: new Date().toISOString().slice(0, 10),
      checkEvent: '',
      sch_length: 0,
      moveScroll: 0,
      scheduled_array: [{
        id: 0,
        sch_id: 0,
        row_id: 0,
        sch_date: '',
        sch_comment: '',
        is_cmp: 0,
        s_type: 0,
      }],
      trainingCount: 3,
      another: false,
      another1: false,
      awaitingSearch: false,
      search: "",
      add_migration: false,
      schedule_complete: 0,
      schedule_complete1: 0,
      schedule_complete2: 0,
      selectedClass: {
        name: '',
        index: 0,
        id: 0,
      },
      sel_tab: 0,
      countBoard: [],
      countScheduleBoard: [],
      countScheduleBoardCount: [],
      countFollowupBoard: [],
      countFollowupBoardCount: [],
      onboardLead: [],
      onboarding: this.get_onboarding_obj(),
      onboard_status: 0,
      onboardDate: '',
      check_box: false,
      checked: false,
      followupDelete: '',
      scheduleDelete: '',
      lengthCheckSchedule: false,
      lengthCheckFollowup: false,
      customer_interest_value: 0,
      isLoader: true,
      role_id: 0,
      data_migration_edit_status:false,
      training_session_edit_status:false,
      add_more: false,
      email:[],
      add_contact: true,
      add_more_training_session: false,
      attachments: {},
      attachment: {},
      aws_base_path:"",
      isVisible: false,
      add_more_session:false,   
      today: new Date(),
      meetingLoader:false,
    };
  },
  filters: {
    subStr: function (string) {
      return string.substring(0, 15) + '...';
    }
  },
  computed: {
    demoLeads: function () {
      this.get_onboarding_obj();
      if (this.onboarding.schedule_date == undefined) {
        this.onboarding.schedule_date = this.schDate;
      }

      this.onboarding.next_schedule_date = new Date()
        .toISOString()
        .slice(0, 10);
      return this.$store.getters["users/demoLeads"];
    },
    totalPages: function () {
      return this.$store.getters["users/totalPages"];
    },
    totalLeads: function () {
      return this.$store.getters["users/totalLeads"];
    },
    totalRows: function () {
      return this.$store.getters["users/totalRows"];
    },
    currentPage: {
      get: function () {
        return this.page;
      },
      set: function () { },
    },
  },
  created: function () {
    this.role_id = JSON.parse(localStorage.getItem("role"));
    if (this.role_id == 5) {
      this.selTab(1);
      this.demotabs(1);
    }else{
      this.page = helpers.getPageQuery();
    }
    this.fetchData();
    this.is_checked = "";
    this.rec_checked = "";
    this.is_schedule = "";
    this.checked = false;
    this.onboarding.schedule_date = new Date().toISOString().slice(0, 10);
    this.onboarding.final_date = new Date().toISOString().slice(0, 10);
    this.onboarding.next_schedule_date = new Date().toISOString().slice(0, 10);
    this.schDate = new Date().toISOString().slice(0, 19);
    
  },
  watch: {
    page: function (val) {
      this.isLoader = true;
      this.$store
        .dispatch("users/getAllDemoLeads", [val, "", this.selectTab, "", "", "", "", "", "", "", 0])
        .then(() => {
          setTimeout(() => {
            this.isLoader = false;
          }, 1 * 500)
        });
    },
  },
  methods: {
    onBoarding(event) {
        let lead_id = event.target.dataset.id;
        this.$store.dispatch("modal/onBoarding", {
                action: "create",
                title: "Processing Type (Please select what represents the major part of your business e.g) If its 70 percent rentals and 30 percent COG then select rentals",
                formData: {
                    lead_id: lead_id
                },
                component: boardingForm,
            });
      },
     editDate(completed) {
      let today = new Date();
      let year = today.getFullYear();
      let month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      let day = String(today.getDate()).padStart(2, '0');
      let hours = String(today.getHours()).padStart(2, '0');
      let minutes = String(today.getMinutes()).padStart(2, '0');
      let seconds = String(today.getSeconds()).padStart(2, '0');
      let formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      this.isEditing = true;
      this.receiveDate = formattedDateTime;
    },
   async saveDate(id,lead) {
    let date_type = ''
    if(this.receiveDate =='')
    {
      this.$toast.error('Receive date is required');
      return false;
    }
          let formData = {
            lead:lead,
            id: id,
            status:1,
            stage:1,
            completed_at: this.receiveDate,
            
          };
       let loader = this.$loading.show({
          loader: "dots",
          container: this.fullPage ? null : this.$refs.formContainer,
        });
       
      try {
       await this.$store.dispatch("users/leadRecevied", { formData });
        this.isEditing = false;
         loader.hide();
        this.$toast.success('Data Received Successfully');
      } catch (error) {
        console.error("Error saving date:", error);
      }
      await this.$store.dispatch("users/getAllDemoLeads", [
        1,
        "",
        this.selectTab,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        0,
      ]);
    },
  cancelEdit() {
    this.isEditing = false;
    this.receiveDate = this.value.completed_at;
  },
    zoomModal() {
      this.fetchData();
      this.$bvModal.show('zoom_meetings');
    },
    fetchData() {
      this.meetingLoader = true;
      this.$http.get('list?schedule_for='+this.onboarding.schedule_for)
        .then(response => {
          if (response.data.success){
            this.meetingsData = response.data.data.meetings;
          } else {
            console.error('Request failed:', response.data.error);
          }
          this.meetingLoader = false;

        })
        .catch(error => {
          console.error('Error:', error);
        });
    },
    formattedStartTime(start_time) {
    const startTime = new Date(start_time);
    return (startTime.toLocaleString('en-US', {
      timeZone: 'UTC',}));
  },
  scheduleMeetings() {
    let meetings = this.meetingsData;
    let oneHourInMillis = 60 * 60 * 1000; // One hour in milliseconds
    let schedule_time = new Date(this.onboarding.schedule_for);
    let oneHourBefore = new Date(schedule_time.getTime() - oneHourInMillis);
    let oneHourAfter = new Date(schedule_time.getTime() + oneHourInMillis);
    meetings.forEach(element => {
    let time = new Date(element.start_time).toLocaleString('en-US', { timeZone: 'UTC' });
      if (schedule_time.getTime() === new Date(time).getTime() || (new Date(time) > oneHourBefore && new Date(time) < oneHourAfter))
      {  
        this.already_schedule = true;
        // this.onboarding.schedule_for = '';
      }
    });
  },

    setPage(page) {
      this.page = page;
    },
    selTab(event) {
      this.sel_tab = event;
      this.setPage(1);
    },
    customer_interest(status) {
      status === '' ? status = 1 : status = status;
      switch (status) {
        case 0:
          return "VERY SLOW";
        case 1:
          return "MOTIVATED";
        case 2:
          return "HYPER";

      }
    },
    showOnboarding(id, onboardlead, onboardingLead) {
        this.onboardLead = onboardlead;
        this.onboarding.contact_emails = onboardingLead.email_list;
        this.onboarding.assign_to = onboardingLead.assign_to;
        this.onboarding.onboarding_by = onboardlead.onboarding_by;
        this.onboarding.timezone = (onboardingLead.timezone != null) ?  onboardingLead.timezone :'US/Eastern';
        this.aws_base_path = onboardingLead.aws_path;
        if(onboardingLead.sessions.length>0 ){
          this.add_more_session = (onboardingLead.sessions[onboardingLead.sessions.length-1].status == 0 && onboardingLead.follow_ups.length>0) ? true : false;
        }
        if (this.row_id == -1) {
          this.row_id = id;
        } else {
          this.row_id = -1;
        }
      },
  
    leadsBySearch() {
      if (!this.awaitingSearch) {
        setTimeout(() => {
          this.isLoader = true;
          this.$store
            .dispatch("users/getleadsBySearch", [
              1,
              this.search,
              this.selectTab,
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              0,
            ])
            .then(() => {
              this.isLoader = false;
            });
          this.awaitingSearch = false;
        }, 200);
      }
      this.awaitingSearch = true;
    },
    changeLeadStatus(event) {
      let lead_id = event.target.dataset.id;
      let lead_status = event.target.value;
      this.isLoader = true;
      this.$store
        .dispatch("users/changeLeadStatus", [lead_status, lead_id])
        .then(() => {
          setTimeout(() => {
            this.isLoader = false;
          }, 1500);
        });
      this.$store.dispatch("users/getAllDemoLeads", [
        1,
        "",
        this.selectTab,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        0,
      ]);
    },
    demotabs(status) {
      this.row_id = -1;
      this.moveScroll = 0;
      this.check_box = false;
      this.selectTab = status;
      this.search = '';
      this.isLoader = true;
      this.$store
        .dispatch("users/getAllDemoLeads", [
          1,
          "",
          this.selectTab,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          0,
        ])
        .then(() => {
          this.isLoader = false;
        });
    },
    getOrgTime(time_zone){
      this.$store.dispatch("users/getOrgTime", time_zone).then((response)=>{
        this.onboarding.org_current_time= response;
      });
    },
    save(type,index,cmp_section){
      let schedule_for,schedule_comment,completed_at,is_completed,completed_comment,section,zoom_meeting,session_name,session_n,session_index,session_status,date_type = '';
      let date_error = false;
      let comment_req = false;
      let add_more = this.add_more;
      let next_expected_date = this.onboarding.next_expected_date;
      let lead_assign_to_id=this.onboarding.assign_to;
      let orgaization_id = this.onboarding.org_id;
      let send_email_for_set_crendentials = this.onboarding.send_email_for_set_crendentials;
      let contact_emails = this.onboarding.contact_emails;
      let training_session_request_in_followup = this.add_more_training_session;
      let org_current_time = (this.onboarding.org_current_time != '') ? new Date(this.onboarding.org_current_time) :this.today;
      zoom_meeting = this.onboarding.zoom_meeting;
      if(this.onboarding.stage_section == 'started' || (new Date(cmp_section.schedule_for) >org_current_time && type!=2 && cmp_section.completed_at == null)){
        if(zoom_meeting)
        {
          this.scheduleMeetings();
        }
        // if(this.onboarding.stage_section == 'started' || (new Date(cmp_section.schedule_for) > org_current_time && type!=2  && cmp_section.completed_at == null)){
          schedule_for = this.onboarding.schedule_for;
          schedule_comment = this.onboarding.schedule_comment;
          session_status = "scheduled";
          if(schedule_for=='' || (this.onboarding.next_expected_date == '' && type==2 )){
            date_error = true; 
            if(type==2 ){
              date_type = (this.onboarding.next_expected_date == '') ? "Starting date":" Delivery for date";
            }else{
              date_type = "Scheduled date";  
            }
            
            
          }else{
            date_error = false;
          }
      // }
    }  else{
        completed_at = this.onboarding.completed_at;
        is_completed = (this.onboarding.is_completed == true )? 1 :0 ;
        completed_comment = this.onboarding.completed_comment;
        session_status = "completed";
        if(is_completed != 1 && !completed_comment){
          comment_req =true; 
          completed_at = null;
        }
        if(this.onboarding.stage_section == 'completed' && ((is_completed !== undefined && type !=2 && !this.add_more_session)&& (this.onboarding.completed_at =='' ||( this.onboarding.next_expected_date == '' && type !=2 && !this.add_more_session)) || ((this.onboarding.completed_at ==''||  this.onboarding.next_expected_date == '') && this.add_more_session )||(this.onboarding.completed_at == '' && type ==2 && !this.add_more_session)) ){   //|| this.next_expected_date == ''
          
          if(!this.add_more_session || type!=3){
            date_error = true; 
            date_type = (this.onboarding.next_expected_date == '' && type !=2) ? "Next expected date":"Completion date";
          }else if(this.add_more_session && type==3 && this.onboarding.completed_at == ''){
            date_error = true; 
            date_type = "Completion Date" ;   
          }
          
        }else{
          date_error = false;
        }
      }
      if(type == 1 || type == 2){
          session_name = "Data Migration";
          session_n = "Data Migration";
        }else if(type == 3){
          session_index = index+1;
          session_n= 'Training Session ';
          session_name = (is_completed != 0) ? session_n+session_index :'Training Session';
        }else if(type == 4){
          session_index = index+1;
          session_n = "Followup ";
          session_name = (is_completed != 0) ? session_n+ session_index:"Followup ";
        }
      if(date_error){
        if(this.already_schedule && zoom_meeting && new Date(this.onboarding.schedule_for) >= new Date()){
          this.$toast.error('Meeting already scheduled');
        }else{
          this.$toast.error(date_type+" is required.");
        }  
      }else if(comment_req){
        this.$toast.error("Provide reason in comment section for not completing "+session_n+'.');
      }else{
        let loader = this.$loading.show({
          loader: "dots",
          container: this.fullPage ? null : this.$refs.formContainer,
        });
        this.$store.dispatch("users/postOnboarding", [
          this.row_id,
          this.onboarding.id,
          this.onboarding.lead_onboarding_id,
          this.onboarding.type,
          schedule_for,
          schedule_comment,
          is_completed,
          completed_at,
          completed_comment,
          add_more,
          next_expected_date,
          lead_assign_to_id,
          zoom_meeting,
          contact_emails,
          send_email_for_set_crendentials,
          orgaization_id,
          training_session_request_in_followup,
          this.onboarding.onboarding_by,
          this.add_more_session,
          this.onboarding.zoom_recording_link,
          this.onboarding.passcode,
        ])
        .then((response) => {
            if(response != "Request failed with status code 422" && response !="Request failed with status code 500" && response.status == 200){
              this.$store.dispatch("users/getAllDemoLeads", [
                this.currentPage,
                this.search,
                this.selectTab,
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                0,
              ]).then(() => {
                if(this.role_id != 2){
                  if(type == 2) {
                    this.data_migration_edit_status = false;
                  }else  if(type == 3) {
                      section = 'training';
                      this.styleCancel(section,index);
                  }else  if(type == 4) {
                      section = 'followup';
                      this.styleCancel(section,index);
                  }
                }
                
                this.training_session_edit_status = (type==3)? true: '';
                this.add_more_session = (this.onboarding.stage_section == 'completed' &&  is_completed == 1)? false : true;
                loader.hide();
                let toastr_msg='';
                if(is_completed != 0){
                  toastr_msg = session_name+" has been "+ session_status +" successfully";
                }else{
                  session_name = (type == 4 && training_session_request_in_followup)? 'Training Session' : session_name;
                  toastr_msg = "New "+session_name+" has been Added Successfully";
                }
                  this.$toast.success(toastr_msg);
                
                
              }); 
            }else{
              loader.hide();
               if(response == "Request failed with status code 422"){
                this.$toast.error('Meeting cannot be scheduled in the past.');
              }else if(response.status == 422){
                this.$toast.error(response.error);
              }else{
                this.$toast.error('OPPS! Something Went Wrong.')
              }
              
            }
              
        });
      }
            
    },

    get_onboarding_obj() {
      return {
        id: "",
        lead_id: "",
        lead_onboarding_id: "",
        schedule_date: "",
        completion_date: "",
        completion_comment: "",
        type: "",
        is_completed: "",
        is_checked: "",
        final_date: "",
        final_comment: "",
        next_schedule_date: "",
        schedule_for: "",
        schedule_at: "",
        schedule_comment: "",
        completed_at: "",
        completed_comment: "",
        expected_at: "",
        stage_section: "",
        assign_to: "",
        next_expected_date:"",
        zoom_meeting:"",
        zoom_recording_link:"",
        passcode:"",
        contact_emails:[],
        default_org_contact:[],
        org_id: 0,
        onboarding_by:0,
        org_current_time:"",
        send_email_for_set_crendentials: false,
        timezone: null,
      };
    },

    getonboardlead(val, stage, status) {

      for (let k = 0; k < this.onboardLead.stages.length; k++) {
       
        if (this.onboardLead.stages[k].stage == stage) {
          if (val == 1) return this.onboardLead[k].stage;
          else if (val == 2) return this.onboardLead.stages[k].status;
          else if (val == 3) return this.onboardLead.stages[k].schedule_date;
          else if (val == 4) return this.onboardLead.stages[k].schedule_comment;
          else if (val == 5) return this.onboardLead.stages[k].final_date;
          else if (val == 6) return this.onboardLead.stages[k].final_comment;
          else if (val == 7) return this.onboardLead.stages[k].typeCheck;
          else if (val == 8) return this.onboardLead.stages[k].is_checked;
          else if (val == 9) return this.onboardLead.stages[k].completed_at;
          else if (val == 10) return this.onboardLead.stages[k].expected_at;
          else if (val == 11) return this.onboardLead.stages[k].schedule_for;
          else if (val == 12) return this.onboardLead.stages[k].completed_at;
          else if (val == 13) return this.onboardLead.stages[k].schedule_at;
          else if (val == 14) return this.onboardLead.stages[k].expected_at;
        }
      }

    },
    //  Getters and states
    getType(type, typeCheck) {
      let value = this.getonboardlead(1, type, typeCheck);
      return value;
    },
    getiscompleted(stage, status) {   //type=section, typecheck=stage

      let value = this.getonboardlead(2, stage, status);
      return value;
    },
    getscheduledate(type, typeCheck) {
      let value = this.getonboardlead(3, type, typeCheck);
      return value;
    },
    getschedulecomment(type, status) {
      let value = this.getonboardlead(4, type, status);
      return value;
    },
    getfinaldate(type, typeCheck) {
      let value = this.getonboardlead(5, type, typeCheck);
      return value;
    },
    getfinalcomment(type, typeCheck) {
      let value = this.getonboardlead(6, type, typeCheck);
      return value;
    },
    gettypeCheck(type, typeCheck) {
      let value = this.getonboardlead(7, type, typeCheck);
      return value;
    },
    getIsChecked(type, typeCheck) {

      let value = this.getonboardlead(8, type, typeCheck);
      return value;
    },
    getCompletionDate(stage, status) {

      let value = this.getonboardlead(9, stage, status);
      return value;
    },
    getExpectedDate(stage, status) {
      let value =  this.getonboardlead(10, stage, status);
      return value;
    },
    getScheduleFor(stage, status) {
      return this.getonboardlead(11, stage, status);  
    },
    getCompletedAt(stage, status) {
      return this.getonboardlead(9, stage, status);
    },
    getCompletedComment(stage, status) {
      return this.getonboardlead(12, stage, status);  
    },
    getScheduleAt(stage, status) {
      return this.getonboardlead(13, stage, status);  
    },
    getExpectedAt(stage, status) {
      return this.getonboardlead(14, stage, status);  
    },
    addFollowupFilter() {
   
      if (this.countFollowupBoardCount.length == 0) {
        this.lengthCheckFollowup = true;
      }
      this.countFollowupBoardCount.push('');
      this.followupDelete = this.countFollowupBoardCount.length;
    },
    addScheduleFilter() {

      if (this.countScheduleBoardCount.length == 0) {
        this.lengthCheckSchedule = true;
      }
      this.countScheduleBoardCount.push('');
      this.scheduleDelete = this.countScheduleBoardCount.length;
    },
    addFilter() {
      this.countBoard.push('');
    },
    styleFollowupClass(id, index) {
      if (this.selectedClass['id'] == 0 && this.selectedClass['index'] == 0) {

        this.selectedClass['name'] = 'displayFollowup';
        this.selectedClass['id'] = id;
        this.selectedClass['index'] = index;
      }
      else if ((id != this.selectedClass['id']) || (index != this.selectedClass['index'])) {
        this.hideDiv(id, index);
      }
      this.$el.querySelector(".hideFollowup" + index + id).style.display = 'none';
      this.$el.querySelector(".displayFollowup" + index + id).style.display = 'block';
    },
    styleFollowupCancel(id, index) {
      this.$el.querySelector(".hideFollowup" + index + id).style.display = 'block';
      this.$el.querySelector(".displayFollowup" + index + id).style.display = 'none';
    },
    styleScheduleClass(id, index) {
      this.$el.querySelector(".hideSchedule" + index + id).style.display = 'none';
      this.$el.querySelector(".displaySchedule" + index + id).style.display = 'block';
    },
    styleScheduleCancel(id, index) {
      this.$el.querySelector(".hideSchedule" + index + id).style.display = 'block';
      this.$el.querySelector(".displaySchedule" + index + id).style.display = 'none';
    },
    styleClass(section,index) {
      if(section == "training"){
        this.$el.querySelector("#training_collapse"+index).style.display = 'none';
        this.$el.querySelector("#training_edit"+index).style.display = 'none';
        this.$el.querySelector("#training_expand"+index).style.display = 'block';
        this.$el.querySelector("#training_save"+index).style.display = 'block';
        this.$el.querySelector("#training_cancel"+index).style.display = 'block';
        this.training_session_edit_status = true;
      }else if(section == "followup"){
        this.$el.querySelector("#followup_collapse"+index).style.display = 'none';
        this.$el.querySelector("#followup_edit"+index).style.display = 'none';
        this.$el.querySelector("#followup_expand"+index).style.display = 'block';
        this.$el.querySelector("#followup_save"+index).style.display = 'block';
        this.$el.querySelector("#followup_cancel"+index).style.display = 'block';
      }
      
    },
    styleCancel(section,index) {
      if(section == "training"){
        this.$el.querySelector("#training_collapse"+index).style.display = 'block';
        this.$el.querySelector("#training_edit"+index).style.display = 'block';
        this.$el.querySelector("#training_expand"+index).style.display = 'none';
        this.$el.querySelector("#training_save"+index).style.display = 'none';
        this.$el.querySelector("#training_cancel"+index).style.display = 'none';
        this.training_session_edit_status = false;
      }else if(section == "followup"){
        this.$el.querySelector("#followup_collapse"+index).style.display = 'block';
        if(!this.add_more_training_session){
          this.$el.querySelector("#followup_edit"+index).style.display = 'block';
        }
       
        this.$el.querySelector("#followup_expand"+index).style.display = 'none';
        this.$el.querySelector("#followup_save"+index).style.display = 'none';
        this.$el.querySelector("#followup_cancel"+index).style.display = 'none';
      }
    },
    sectionStyle(type,val){
      if(type == 1){
        this.data_migration_edit_status= val;
      }else if(type == 2){
        this.training_session_edit_status = val;
      }
      
    },
    
    hideDiv(id, index) {
      if (this.selectedClass['id'] == 1 || this.selectedClass['id'] == 2 || this.selectedClass['id'] == 3 || this.selectedClass['id'] == 4) {
        this.selectedClass['name'] = 'onboard';
      } else if (this.selectedClass['id'] == 5 || this.selectedClass['id'] == 6 || this.selectedClass['id'] == 7 || this.selectedClass['id'] == 8 || this.selectedClass['id'] == 9 || this.selectedClass['id'] == 10) {
        this.selectedClass['name'] = 'displaySchedule';
      } else {
        this.selectedClass['name'] = 'displayFollowup';
      }
      if (this.selectedClass['name'] == 'onboard') {
        this.styleCancel(this.selectedClass['id'], this.selectedClass['index']);
        this.selectedClass['id'] = id;
        this.selectedClass['index'] = index;
      } else if (this.selectedClass['name'] == 'displaySchedule') {
        this.styleScheduleCancel(this.selectedClass['id'], this.selectedClass['index']);
        this.selectedClass['id'] = id;
        this.selectedClass['index'] = index;
      } else if (this.selectedClass['name'] == 'displayFollowup') {
        this.styleFollowupCancel(this.selectedClass['id'], this.selectedClass['index']);
        this.selectedClass['id'] = id;
        this.selectedClass['index'] = index;
      }
    },
    hoverDisplay(id, index) {
      if ((id != 9 && id != 11 && id != 15) && (id - 1 != 0)) {
        if (this.getiscompleted(id - 1, index)) {
          this.$el.querySelector(".hover" + index + id).style.display = 'inline-block';
        }
      } else if (id == 9 || id == 11) {
        if (this.getiscompleted(8, 0) && (id == 9 || id == 11)) {
          this.$el.querySelector(".hover" + index + id).style.display = 'inline-block';
        } else if (this.getiscompleted(14, 0) && (id == 15)) {
          this.$el.querySelector(".hover" + index + id).style.display = 'inline-block';
        }
      } else {
        this.$el.querySelector(".hover" + index + id).style.display = 'inline-block';
      }
    },
    hoverHide(id, index) {
      if ((id != 9 && id != 11 && id != 15) && (id - 1 != 0)) {
        if (this.getiscompleted(id - 1, index)) {
          this.$el.querySelector(".hover" + index + id).style.display = 'none';
        }
      } else if (id == 9 || id == 11 || id == 15) {
        if (this.getiscompleted(8, 0) && (id == 9 || id == 11)) {
          this.$el.querySelector(".hover" + index + id).style.display = 'none';
        } else if (this.getiscompleted(14, 0) && (id == 15)) {
          this.$el.querySelector(".hover" + index + id).style.display = 'none';
        }
      } else {
        this.$el.querySelector(".hover" + index + id).style.display = 'none';
      }
    },
    getSelectedType() {
      if (this.selectedClass['id'] == 1 || this.selectedClass['id'] == 2 || this.selectedClass['id'] == 3 || this.selectedClass['id'] == 4) {
        this.styleCancel(this.selectedClass['id'], this.selectedClass['index']);
      } else if (this.selectedClass['id'] == 5 || this.selectedClass['id'] == 6 || this.selectedClass['id'] == 7 || this.selectedClass['id'] == 8 || this.selectedClass['id'] == 9 || this.selectedClass['id'] == 10) {
        this.styleScheduleCancel(this.selectedClass['id'], this.selectedClass['index']);
      } else {
        this.styleFollowupCancel(this.selectedClass['id'], this.selectedClass['index']);
      }
      this.check_box = false;
      this.moveScroll--;
    },
    getCheckedCmp(type, ind) {
      this.onboarding.is_checked = 0;
      if (this.$el.querySelector("#id_cmp" + ind + type).checked == true) {
        this.$el.querySelector("#id_cmp" + ind + type).checked = false;
      }

    },
    getChecked(type, ind) {
      this.$el.querySelector("#id_cmp" + ind + type).checked == true ? this.onboarding.is_checked = 1 : this.onboarding.is_checked = 0;
      this.onboarding.final_date = this.schDate;
      if (type > 4 && type < 17 && type % 2 != 0 && this.$el.querySelector("#id_cmp" + ind + type).checked == true) {
        this.$el.querySelector("#idCmp" + ind + type).checked = false;
      }

    },
    popFollowup() {

      if (this.followupDelete != '' && this.followupDelete != null) {
        if (this.lengthCheckFollowup = true) {
          this.followupDelete = this.followupDelete - 1;
          this.countFollowupBoardCount.splice(this.followupDelete, 1);
          this.countFollowupBoardCount[this.followupDelete - 1] == null || this.countFollowupBoardCount[this.followupDelete - 1] == "" ? this.followupDelete = this.followupDelete : this.followupDelete = '';
        } else {
          this.countFollowupBoardCount.splice(this.followupDelete, 1);
          this.countFollowupBoardCount[this.followupDelete - 1] == null || this.countFollowupBoardCount[this.followupDelete - 1] == "" ? this.followupDelete = this.followupDelete - 1 : this.followupDelete = '';
        }
      }
    },
    popSchedule() {
      if (this.scheduleDelete != '' && this.scheduleDelete != null) {
        if (this.lengthCheckSchedule = true) {

          this.scheduleDelete = this.scheduleDelete - 1;
          this.countScheduleBoardCount.splice(this.scheduleDelete, 1);
          this.countScheduleBoardCount[this.scheduleDelete - 1] == null || this.countScheduleBoardCount[this.scheduleDelete - 1] == "" ? this.scheduleDelete = this.scheduleDelete : this.scheduleDelete = '';
        } else {
          this.countScheduleBoardCount.splice(this.scheduleDelete, 1);
          this.countScheduleBoardCount[this.scheduleDelete - 1] == null || this.countScheduleBoardCount[this.scheduleDelete - 1] == "" ? this.scheduleDelete = this.scheduleDelete - 1 : this.scheduleDelete = '';
        }
      }
    },
    updateStatus(event) {
      let lead_data_id = event.target.dataset.id;
      let lead_data_status = event.target.dataset.status;
      this.$store.dispatch("users/updateOnboaringStatus", [lead_data_id, lead_data_status]).then((res) => {
        if (res.message) {
          this.$toast.success(res.message);
        } else {
          this.$toast.error(res.error);
        }

        this.$store.dispatch("users/getAllDemoLeads", [
          1,
          this.search,
          this.selectTab,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          0,
        ]).then(() => {

        });
      });
    },
    add_contacts(){
      $(".email_action").css('display', 'none');
      this.onboarding.contact_emails.push('');
      this.email= '';
      this.add_contact = false;
    },
    popContact(type,index){
      if(this.onboarding.contact_emails[index] == ''){
        this.onboarding.contact_emails.splice(index, 1);
        this.$el.querySelector("#update_contact"+type+index).style.display = 'block';
        this.$el.querySelector("#delete_contact"+type+index).style.display = 'block';
        this.$el.querySelector("#save_contact"+type+index).style.display = 'none';
        this.$el.querySelector("#cancel_contact"+type+index).style.display = 'none';
        this.email='';
        this.add_contact = true;
      }else{
        this.onboarding.contact_emails.splice(index, 1);
        this.$el.querySelector("#display_contact"+type+index).style.display = 'block';
        this.$el.querySelector("#add_contact"+type+index).style.display = 'none';
        this.$el.querySelector("#update_contact"+type+index).style.display = 'block';
        this.$el.querySelector("#delete_contact"+type+index).style.display = 'block';
        this.$el.querySelector("#save_contact"+type+index).style.display = 'none';
        this.$el.querySelector("#cancel_contact"+type+index).style.display = 'none';
      }
      if(this.onboarding.contact_emails.length == 0){
        this.onboarding.zoom_meeting = false;
      }
    },
    saveContact(type,index){
      if(this.onboarding.contact_emails[index] == ''&& this.email!=''){
        this.onboarding.contact_emails.splice(index, 1);
        this.onboarding.contact_emails.push(this.email);
        this.$el.querySelector("#display_contact"+type+index).style.display = 'block';
        this.$el.querySelector("#add_contact"+type+index).style.display = 'none';
        this.$el.querySelector("#update_contact"+type+index).style.display = 'block';
        this.$el.querySelector("#delete_contact"+type+index).style.display = 'block';
        this.$el.querySelector("#save_contact"+type+index).style.display = 'none';
        this.$el.querySelector("#cancel_contact"+type+index).style.display = 'none';
      }else if(this.onboarding.contact_emails[index] != ''){
        this.onboarding.contact_emails.splice(index, 1);
        this.onboarding.contact_emails.splice(index, 0,this.email);
        this.$el.querySelector("#display_contact"+type+index).style.display = 'block';
        this.$el.querySelector("#add_contact"+type+index).style.display = 'none';
        this.$el.querySelector("#update_contact"+type+index).style.display = 'block';
        this.$el.querySelector("#delete_contact"+type+index).style.display = 'block';
        this.$el.querySelector("#save_contact"+type+index).style.display = 'none';
        this.$el.querySelector("#cancel_contact"+type+index).style.display = 'none';
      }else if(this.email == ''){
        this.onboarding.contact_emails.splice(index, 1);
        this.$el.querySelector("#display_contact"+type+index).style.display = 'none';
        this.$el.querySelector("#update_contact"+type+index).style.display = 'none';
        this.$el.querySelector("#delete_contact"+type+index).style.display = 'none';
      }
      $(".email_action").css('display', 'block');
      this.email='';
      this.add_contact = true;    
    },
    updateContact(type,index){
      this.email = this.onboarding.contact_emails[index];
     
      this.$el.querySelector("#display_contact"+type+index).style.display = 'none';
      this.$el.querySelector("#add_contact"+type+index).style.display = 'block';
      this.$el.querySelector("#update_contact"+type+index).style.display = 'none';
      this.$el.querySelector("#delete_contact"+type+index).style.display = 'none';
      this.$el.querySelector("#save_contact"+type+index).style.display = 'block';
      this.$el.querySelector("#cancel_contact"+type+index).style.display = 'block';
      $(".email_action").css('display', 'none');
      this.add_contact = false;
    },
    cancelContact(type,index){
      if(this.email == ''){
        this.onboarding.contact_emails.splice(index, 1);
        this.$el.querySelector("#display_contact"+type+index).style.display = 'none';
        this.$el.querySelector("#update_contact"+type+index).style.display = 'none';
        this.$el.querySelector("#delete_contact"+type+index).style.display = 'none';
      }else{
      this.email = this.onboarding.contact_emails[index];
      this.$el.querySelector("#display_contact"+type+index).style.display = 'block';
      this.$el.querySelector("#add_contact"+type+index).style.display = 'none';
      this.$el.querySelector("#update_contact"+type+index).style.display = 'block';
      this.$el.querySelector("#delete_contact"+type+index).style.display = 'block';
      this.$el.querySelector("#save_contact"+type+index).style.display = 'none';
      this.$el.querySelector("#cancel_contact"+type+index).style.display = 'none';
      }
      $(".email_action").css('display', 'block');
      this.add_contact = true;
    },
    open(attachment){
      $('.content-wrapper').css('height','100vh');
      $('.content-wrapper').css('overflow-y','hidden');
      this.attachment=attachment;
      this.isVisible = true;
    },
    setVisibility(show_popup){
        this.isVisible = show_popup;
      },
    setOrgStatus(status){
      if(this.onboarding.is_completed == true && status==2){
        this.onboarding.send_email_for_set_crendentials = false; 
        this.add_more = true;
      }else if(this.onboarding.is_completed == true && status!=2){
        this.onboarding.send_email_for_set_crendentials = false; 
        this.add_more = true;
      }
    },
    addMore(lead,lead_id,onboarding_id,stage,org_id,stage_name){
      let loader = this.$loading.show({
          loader: "dots",
          container: this.fullPage ? null : this.$refs.formContainer,
        });
       this.$store.dispatch("users/addMore", [
          lead_id,
          onboarding_id,
          org_id,
          stage,
        ])
        .then((response) => {
      this.$store.dispatch("users/getAllDemoLeads", [
        this.currentPage,
        this.search,
        this.selectTab,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        0,
      ]).then(() => {
        if(stage_name == 'training') {
           let index =lead.follow_ups.length-1;
            this.$el.querySelector("#followup_collapse"+index).style.display = 'block';
            this.$el.querySelector("#followup_expand"+index).style.display = 'none';
            this.$el.querySelector("#followup_save"+index).style.display = 'none';
            this.$el.querySelector("#followup_cancel"+index).style.display = 'none';
            loader.hide();
            this.$toast.success("New training session has been added");
        }else if(stage_name == 'followup') {
            let index =lead.sessions.length-1;
            this.$el.querySelector("#training_collapse"+index).style.display = 'block';
            this.$el.querySelector("#training_expand"+index).style.display = 'none';
            this.$el.querySelector("#training_save"+index).style.display = 'none';
            this.$el.querySelector("#training_cancel"+index).style.display = 'none';
            loader.hide();
            this.$toast.success("New followup has been added");
        }
        this.training_session_edit_status = ( this.onboarding.type==3)? true: '';
      });
      });
    },
    addFollowup(){
      this.onboarding.next_expected_date = (this.onboarding.next_expected_date=='')?this.schDate:this.onboarding.next_expected_date;
      this.add_more= (!this.add_more_training_session)?false:true;
      this.add_more_session = false;
    },
    attachmentLink(lead){
      this.$toast.success("Attachment link will be send in few moments...");
      this.$store.dispatch("users/dataAttachmentLink", [lead.id,lead.data_request[0].lead_onboarding_id,true]);        
    },
    trialenddate(status_selected,org_id) {
        this.$store.dispatch("modal/trialDateForm", {
          action: "create",
          title: "Update Trial Date",
          formData: {
            status_selected: status_selected,
            org_id: org_id,
            // trial_in_days:true,
            page:this.currentPage,
            search:this.search,
            tab:this.selectTab,
          },
          component: trialDateForm,
        });
        
      },
    startTrial(org_id){
      this.$store.dispatch("organizations/startTrial", [org_id])
            .then(() => {
              // send successful message
              this.$toast.success('Organization trial has been started successfully...');
              setTimeout(() => {

                  this.organization_id = '';
                   this.showstatus = false;
                   this.$store.dispatch("users/getAllDemoLeads", [
                      this.currentPage,
                      this.search,
                      this.selectTab,
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      0,
                    ])
          }, 1000)
        });
    }
  },
  crmUsersStyle(index,training_session){
    if(this.role_id == 2 && index == 0 && training_session[index].schedule_for == null){
      this.$el.querySelector("#training_edit"+index).style.display = 'block';
    }else if(this.role_id == 2){
      this.$el.querySelector("#training_edit"+index).style.display = 'none';
    }
  },
};
</script>
<style>
.modal-dialog.modal-md{
  max-width: 50% !important;
  width: 55% !important;
}
.pointer-events {
  pointer-events: none !important;
}

.fa-edit {
  display: block;
}

#tabs .nav-link {
  background: transparent;
  color: #323A47;
}



.transit-enter {
  transform: translateY(-30px);
  opacity: 0;
}

.transit-enter-active {
  transition: all 0.5s ease-in;
}

.transit-enter-to {
  /* transition: all .8s ease; */
}

.transit-leave {}

.transit-leave-active {
  transition: all 0.5s ease-out;
}

.transit-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

.hyper {
  background-color: #ebf7df;
  color: #66b34d;
  font-weight: bold;
  /* border: 1px solid #66b34d; */
}

.slow {
  background-color: #FEF2E6;
  color: #F19A16;
  font-weight: bold;
  /* border: 1px solid #f19a16; */
}

.v-slow {
  background-color: #fbeeff;
  color: #a682b2;
  font-weight: bold;
  /* border: 1px solid #a682b2; */
}

.no-interest {
  color: #495057;
  border: 1px solid #ced4da;
}

.interest {
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  padding: 0.375rem 0.75rem;
  width: 100%;
}

.divScroll::-webkit-scrollbar {
  width: 5px !important;
}

.divScroll::-webkit-scrollbar-thumb {
  background-color: rgb(160 180 194);
  border-radius: 15px;

}

.divScroll::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(225 230 245);
  border-radius: 15px;
}

.form-control {
  border-radius: 0.5rem !important;
}

input[type="datetime-local"].form-control {
  font-size: 12px !important;
  height: calc(1.5em + 0.5rem + 2px) !important;
}

.btn:not(:disabled):not(.disabled) {
  border-radius: 0.5rem !important;
}

div.dataTables_wrapper {
  width: F00px;
  margin: 0 auto;
}

.form-check-label.btn:hover {
  color: #457eac !important;
}


.table td{
    border-bottom-color: 1px solid #48A6A6;
  }
</style>
<style scoped lang="scss">@import "../../assets/sass/variables";

.quick-view-color {
  color: $theme-green-color;
}

.form-condtrol:focus {
  border-color: $theme-green-color !important;
  // box-shadow :0 0 0 0.2rem rgb(0 123 255 / 25%) ;
}
.button-custom-style{
  font-weight: bold!important;
  padding: 0.2rem 0.65rem !important;
  font-size: 0.575rem !important;
}
.btn-success{
  color: white !important;
  background-color: $theme-green-color !important;
  border: 1px solid $theme-green-color !important;
}
.btn:not(:disabled):not(.disabled){
  border-radius: 4px !important;
}
.row:not(.custom_margin_top){
  margin-top: 0px !important;
}
.custom-margin-top{
  padding-top: 6px !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
}

.switch .input-toggle { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  content: "";
  height: 21px;
  width: 41px;
  left: 4px;
  bottom: 2px;
  background-color: #ccc !important;
  // background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 17px;
  width: 17px;
  left: 2px;
  bottom: 1px;
  background-color: $theme-green-color;
  -webkit-transition: .4s;
  transition: .4s;
}

.input-toggle:checked + .slider {
  background-color: white !important;
}

.input-toggle:focus + .slider {
  box-shadow: 0 0 1px $theme-green-color;
}

.input-toggle:checked + .slider:before {
  -webkit-transform: translateX(18px);
  -ms-transform: translateX(18px);
  transform: translateX(18px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
  border: 1px solid #DADADA;
}

.slider.round:before {
  border-radius: 50%;
  border: 1px solid #DADADA;
}
input {
    position: relative;
}
input[type="datetime-local"]::-webkit-calendar-picker-indicator {
    background-position: right;
    background-size: auto;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    left: 0;
    top: 18% !important;
    right: 2%;
    width: auto;
}
.dropdown-menu {
  transform: translate3d(1504px, 153px, 0px);
  width: 7%;
  min-width: 20px !important;
}
.tooltip {
  border: 0px solid black !important;
  top: -17px !important;
}

table tr td:nth-child(3) {
  width: 8%;
}

table tr td:nth-child(4) {
  width: 10%;
}

input[type="checkbox"]:checked {
  accent-color: green;
  color: #ebf7df;
  /* background: rgb(48 173 97); */
  /* display: block; */
  /* border: solid white; */
}

.table thead tr td {
  padding: 1.1rem 0.5rem !important;
}

.b-skeleton {
  background-color: #EEF4F4 !important
}
.badge.badge-warning{
  background-color: #FEF2E6 !important;
  color: #F19A16;
}
.badge.badge-success{
  background-color: #EBF7DF !important;
  color: #6EB756;
}
.badge.badge-danger{
  background-color: #eb575726 !important;
  color: #EB5757;
}
select {
  -moz-appearance: none !important;
  -webkit-appearance: none !important;
}

select:focus-visible {
  outline-offset: none !important;
  outline: none !important;
  outline-color: none !important;
  outline-style: none !important;
  outline-width: none !important;
}

table {
  width: 100% !important;
  min-width: 1503px !important;
}

.table th,
.table td {
  padding: 0.5rem !important;
}

ul.dropdown-menu.action-list {
  transform:translate3d(962px, 181px, 0px) ;
  width: 15% !important;
}

ul.dropdown-menu.action-list li {
  text-align: left;
}

.table tbody+tbody,
.table td {
  border-top: unset !important;
}

.table td {

  border-bottom: 1px solid #48a6a67d !important;
}

.table thead td {
  color: #48A6A6;
  background-color: #EEF4F4;
  font-weight: bold;
}

.form-control:focus {
  border-color: #48A6A6 !important;
  box-shadow: 0 0 0 0.2rem #48a6a191 !important;
}

#tabs .active {
  /* background-color: #266ba2 !important; */
  background-color: #48A6A6 !important;
  color: white;
}
label:not(.switch)::before {
  border-left: dashed 1px #DADADA;
  content: '';
  position: absolute;
  width: 100%;
  height: 90%;
  left: 9px;
  margin-top: 18px;
}
// label::after {
//     // border-left: dashed 2px green;
//     content: "*";
//     position: absolute;
//     width: 100%;
//     height: 100%;
//     left: 1.5px;
// }
.section-heading{
  font-weight: bold;
  font-size: 15px;
  color: #323A47;
}
svg:not(.training_svg){
  margin-top: -5px;
  margin-left: -0.75rem;
  margin-right: 0.3rem;
}
.fa.fa-download{
  color: #48A6A6;
}
.fa-download:focus, .fa-download:active,.fa-download:hover{
  color: #fff !important;
          }

a.btn.dropdown-toggle.float-right.attachment_download:hover > i,a.btn.dropdown-toggle.float-right.attachment_download:focus > i  {
  color: #fff !important;
}
button.btn:hover>i,button.btn:focus>i{
  border: 1px solid;
    padding: 5px 9px;
    color: white !important;
    background-color: #48a6a6;
    border-radius: 4px;
}
button.btn>i{
  padding: 5px 9px;
}



.schedules-list {
  cursor: pointer;
  color: #48a6a6;
  float: right;
 
}

.zoom_meetings-content {
  max-height: 550px; /* Adjust the maximum height as needed */
  overflow-y: auto;
}


table.table.schedules-list
{
  margin-bottom: 0rem !important;
  min-width: 0px !important;

}
.col-md-12.send-link {
    display: flex;
    padding: 0px;
}
// a.btn.dropdown-toggle.float-right.attachment_download:hover > i,a.btn.dropdown-toggle.float-right.attachment_download:focus > i  {
//     color: white !important;
// }
</style>
